document.addEventListener('DOMContentLoaded', () => {
  const uploadBtn = document.getElementById('upload-btn');
  const fileInput = document.getElementById('file-input');
  const popup = document.getElementById('popup');
  const closeBtn = document.querySelector('.close-btn');
  const saveAllBtn = document.getElementById('save-all-btn');
  const uploadStatusMessage = document.getElementById('upload-status-message');
  if (uploadStatusMessage) {
    uploadStatusMessage.classList.add('popup-status-message');
  }
  const imageCardsContainer = document.getElementById('image-cards-container');
  const uploaderContainer = document.querySelector('.uploader-container');
  const mainMessageBox = document.getElementById('main-message-box');
  const imageGrid = document.querySelector('.image-grid');
  const addToCartBtn = document.querySelector('.product-form__submit');
  
  // v17: Guard clause for add-on products (no uploader elements present)
  // If upload button doesn't exist, this is likely an add-on product page - exit gracefully
  if (!uploadBtn) {
    console.log('Uploader v17: No upload button found - this appears to be an add-on product page. Uploader script exiting.');
    return;
  }
  
  // Debug logging switch. Diagnostics are silent for customers; enable them
  // for a testing session from the console with
  //   localStorage.setItem('uploader_debug', '1');  location.reload();
  // or one-off with ?uploaderdebug=1 in the URL. Disable with
  //   localStorage.removeItem('uploader_debug');  location.reload();
  // console.warn / console.error always print regardless of this switch.
  const UPLOADER_DEBUG = /[?&]uploaderdebug=1/.test(window.location.search) ||
    (function () {
      try { return window.localStorage.getItem('uploader_debug') === '1'; }
      catch (e) { return false; }
    })();
  window.UPLOADER_DEBUG = UPLOADER_DEBUG;
  const dlog = UPLOADER_DEBUG ? console.log.bind(console) : function () {};

  // Build stamp: verify a deploy from the console with `window.UPLOADER_BUILD`.
  window.UPLOADER_BUILD = 'uploader v28 release-bitmap 2026-09-14-3';
  console.log('Uploader build:', window.UPLOADER_BUILD);
  if (UPLOADER_DEBUG) console.log('Uploader debug logging: ON');

  // ==========================================================================
  // DIAGNOSTICS  (TEMPORARY - 2026-09 blank-card investigation)
  // --------------------------------------------------------------------------
  // Customers on Facebook's in-app browser report photos that sometimes render
  // as a blank card. GA4 showed 197 in-app decodes with ZERO recorded failures
  // over 28 days, which means the photos are decoding fine and dying somewhere
  // after that - in a stretch of the card-building pipeline that has no error
  // reporting at all.
  //
  // This block adds that reporting. It measures; it does not fix. Every added
  // call site is read-only or a gtag() call, so no existing behaviour changes.
  //
  // The load-bearing check is diagCanvasState(): a canvas that runs out of
  // memory comes back fully transparent instead of throwing, which is why the
  // failure has been invisible. Sampling for zero alpha turns that silent
  // failure into a counted one.
  //
  // TO REMOVE: delete this block and every call to diagSend / diagCardFailed /
  //            diagCanvasState / diagMpBucket, and drop the third argument
  //            from applyOrientation.
  // ==========================================================================

  function diagBucketNum(n, steps) {
    if (typeof n !== 'number' || !isFinite(n) || n <= 0) return 'na';
    for (let i = 0; i < steps.length; i++) if (n <= steps[i]) return String(steps[i]);
    return 'gt' + steps[steps.length - 1];
  }

  // Compact, deliberately coarse environment code. GA4 collapses
  // high-cardinality dimension values into "(other)", which would hide exactly
  // the rare rows this investigation needs, so nothing here is per-device.
  // Example: fb-ios-mem4-c6-dpr3-h1024
  const CLIENT_ENV = (function () {
    try {
      const ua = navigator.userAgent || '';
      let app = 'other';
      if (/FBAN|FBAV|FB_IAB|FBIOS/.test(ua)) app = 'fb';
      else if (/Instagram/.test(ua)) app = 'ig';
      else if (/; wv\)|\bwv\b/.test(ua)) app = 'webview';
      else if (/EdgA?\//.test(ua)) app = 'edge';
      else if (/SamsungBrowser/.test(ua)) app = 'samsung';
      else if (/CriOS|Chrome\//.test(ua)) app = 'chrome';
      else if (/Safari\//.test(ua)) app = 'safari';

      let os = 'other';
      if (/iPhone|iPad|iPod/.test(ua)) os = 'ios';
      else if (/Android/.test(ua)) os = 'android';
      else if (/Macintosh/.test(ua)) os = 'mac';
      else if (/Windows/.test(ua)) os = 'win';

      const mem = navigator.deviceMemory ? ('mem' + navigator.deviceMemory) : 'memNA';
      const cores = navigator.hardwareConcurrency ? ('c' + navigator.hardwareConcurrency) : 'cNA';
      const dpr = 'dpr' + Math.round(window.devicePixelRatio || 1);

      // Chromium exposes a JS heap ceiling; Safari does not. Where present it
      // is the closest thing to a direct read on the memory budget we suspect.
      let heap = '';
      if (window.performance && performance.memory && performance.memory.jsHeapSizeLimit) {
        heap = '-h' + diagBucketNum(
          Math.round(performance.memory.jsHeapSizeLimit / 1048576),
          [256, 512, 1024, 2048, 4096]);
      }
      return (app + '-' + os + '-' + mem + '-' + cores + '-' + dpr + heap).slice(0, 90);
    } catch (e) {
      return 'unknown';
    }
  })();

  // Photo resolution bucket. If blank cards cluster on the largest photos,
  // memory pressure is confirmed and the fix is downscaling earlier.
  function diagMpBucket(w, h) {
    if (!w || !h) return 'na';
    const mp = (w * h) / 1000000;
    if (mp < 2) return 'lt2mp';
    if (mp < 5) return '2-5mp';
    if (mp < 9) return '5-9mp';
    if (mp < 13) return '9-13mp';
    if (mp < 25) return '13-25mp';
    if (mp < 50) return '25-50mp';
    return 'gt50mp';
  }

  // Size of the batch currently being prepared. Paired with photo_index this
  // reconstructs "worked for the first four, blank from the fifth on" without
  // needing session stitching, which GA4 does badly.
  let DIAG_BATCH_SIZE = 0;

  // Nine spread 1x1 reads. A real photo drawn onto a canvas is opaque
  // everywhere (alpha 255); a canvas the browser failed to allocate reads back
  // transparent (alpha 0). Requiring ALL samples to be transparent keeps false
  // positives near zero - an all-white photo is uniform but still opaque, and
  // is reported separately as 'uniform' rather than 'blank'.
  // v28.1: sampled via a reusable 3x3 scratch canvas rather than nine separate
  // getImageData calls on the full-size canvas.
  //
  // The original version cost nine GPU-to-CPU readbacks per check, and the
  // check runs twice per photo - 162 forced syncs for a batch of nine. Chrome
  // flagged it, and on a memory-constrained in-app browser that churn is the
  // last thing this pipeline needs. One scaled drawImage plus one nine-pixel
  // read replaces it.
  //
  // Scaling does not weaken the signal being measured: a canvas the browser
  // failed to allocate reads back fully transparent at any scale, while a real
  // photo is opaque everywhere. willReadFrequently is set on the scratch canvas
  // only, so the working canvases stay GPU-accelerated for drawing.
  let diagScratch = null;
  let diagScratchCtx = null;

  function diagCanvasState(canvas) {
    try {
      if (!canvas || !canvas.width || !canvas.height) return 'no_canvas';
      if (!diagScratch) {
        diagScratch = document.createElement('canvas');
        diagScratch.width = 3;
        diagScratch.height = 3;
        diagScratchCtx = diagScratch.getContext('2d', { willReadFrequently: true });
      }
      if (!diagScratchCtx) return 'no_ctx';

      diagScratchCtx.clearRect(0, 0, 3, 3);
      diagScratchCtx.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, 3, 3);
      const d = diagScratchCtx.getImageData(0, 0, 3, 3).data;

      let transparent = 0, first = null, uniform = true;
      for (let i = 0; i < 9; i++) {
        const o = i * 4;
        if (d[o + 3] === 0) transparent++;
        const key = d[o] + ',' + d[o + 1] + ',' + d[o + 2] + ',' + d[o + 3];
        if (first === null) first = key;
        else if (key !== first) uniform = false;
      }
      if (transparent === 9) return 'blank';
      if (uniform) return 'uniform';
      return 'ok';
    } catch (e) {
      // A browser refusing the read is not evidence of failure either way.
      return 'unreadable';
    }
  }

  // Nothing personal is sent: no filename, no image data, no customer identity.
  function diagSend(eventName, params) {
    if (!window.gtag) return;
    try {
      const payload = Object.assign({
        client_env: CLIENT_ENV,
        batch_size: DIAG_BATCH_SIZE,
        magnet_shape: MAGNET_SHAPE,
        product_url: window.location.pathname
      }, params || {});
      gtag('event', eventName, payload);
      dlog('[diag] ' + eventName, payload);
    } catch (e) {
      // Telemetry must never be able to break an upload.
    }
  }

  function diagCardFailed(stage, params) {
    diagSend('uploader_card_failed', Object.assign({ fail_stage: stage }, params || {}));
  }

  // Uncaught script errors, capped so a noisy unrelated bug cannot flood GA4.
  // Separate event name so it never pollutes the card-failure counts.
  //
  // Known browser-internal noise, filtered so it cannot consume the cap:
  //   _AutofillCallbackHandler - iOS WebKit's own autofill plumbing. Observed
  //     2026-09-04, exclusively on fb-ios: Facebook's in-app browser is a
  //     WebKit shell missing parts of Safari's autofill scaffolding. Not our
  //     code, no effect on uploads.
  // Add to this list only for errors confirmed to originate outside the
  // uploader - a filtered error is an error we can no longer see.
  const JS_ERROR_IGNORE = [
    '_AutofillCallbackHandler'
  ];

  (function () {
    let sent = 0;
    function report(kind, msg) {
      if (sent >= 3) return;
      const text = String(msg || '');
      for (let i = 0; i < JS_ERROR_IGNORE.length; i++) {
        if (text.indexOf(JS_ERROR_IGNORE[i]) !== -1) return;
      }
      sent++;
      diagSend('uploader_js_error', {
        fail_stage: 'js_' + kind,
        error_detail: text.slice(0, 90)
      });
    }
    window.addEventListener('error', function (ev) {
      report('error', ev && ev.message);
    });
    window.addEventListener('unhandledrejection', function (ev) {
      const r = ev && ev.reason;
      report('rejection', r && (r.message || r.name));
    });
  })();

  // ==========================================================================
  // v28 - memory release and the two detectors for silent losses
  // ==========================================================================

  // A decoded photo costs width x height x 4 bytes of bitmap, held by the <img>
  // for as long as the element is referenced - about 118MB for a 31MP camera
  // file, and up to twelve of those at once. After applyOrientation has drawn
  // it onto the downscaled working canvas those pixels are never read again;
  // the card displays the corrected copy, not this one. Pointing src at a 1x1
  // pixel lets the browser drop the bitmap immediately rather than whenever it
  // next collects garbage.
  //
  // naturalWidth/naturalHeight become 1 afterwards, so every caller captures
  // the real dimensions BEFORE calling this.
  const TINY_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  function releaseDecodedImage(img) {
    try {
      if (!img) return;
      img.onload = null;
      img.onerror = null;
      img.src = TINY_GIF;
    } catch (e) { /* best effort - never break a card over a memory hint */ }
  }

  // Cards that never arrive. Every failure caught in the Sept 9-14 window was a
  // blank or uniform canvas at the orientation step - 7 events against roughly
  // 190 photos that decoded and then produced nothing at all. A photo can stall
  // without ever reaching an error handler: a load event that never fires, or a
  // reader that never calls back. Neither throws, so neither is visible today.
  const CARD_WATCHDOG_MS = 30000;
  const cardWatchdogs = new Map();

  function startCardWatchdog(id, ctx) {
    try {
      clearCardWatchdog(id, true);
      cardWatchdogs.set(id, setTimeout(function () {
        cardWatchdogs.delete(id);
        diagCardFailed('card_build_timeout', ctx);
        if (cardWatchdogs.size === 0) clearBuildMarker();
      }, CARD_WATCHDOG_MS));
    } catch (e) { /* telemetry must never block a build */ }
  }

  function clearCardWatchdog(id, keepMarker) {
    try {
      const t = cardWatchdogs.get(id);
      if (t) { clearTimeout(t); cardWatchdogs.delete(id); }
      // The marker exists for exactly as long as some card is still building.
      if (!keepMarker && cardWatchdogs.size === 0) clearBuildMarker();
    } catch (e) { /* no-op */ }
  }

  function clearAllCardWatchdogs() {
    try {
      cardWatchdogs.forEach(function (t) { clearTimeout(t); });
      cardWatchdogs.clear();
      clearBuildMarker();
    } catch (e) { /* no-op */ }
  }

  // The page dying mid-build cannot report itself, so it is recorded before the
  // build starts and read back on the next load.
  //
  // localStorage rather than sessionStorage: an in-app browser that runs out of
  // memory may recreate the tab outright, which sessionStorage would not
  // survive - and that is precisely the case being measured.
  //
  // False positives are bounded two ways. The marker only exists during the few
  // seconds a batch is building, and anything older than the freshness window
  // is discarded unread. The `hidden` flag then separates "customer switched
  // apps mid-build" from "browser killed us while we were on screen", which are
  // very different findings.
  const BUILD_MARKER_KEY = 'tm_uploader_build';
  const BUILD_MARKER_MAX_AGE_MS = 10 * 60 * 1000;

  function writeBuildMarker(count) {
    try {
      localStorage.setItem(BUILD_MARKER_KEY, JSON.stringify({
        t: Date.now(), n: count, env: CLIENT_ENV, shape: MAGNET_SHAPE,
        hidden: 0, phase: 'probe'
      }));
    } catch (e) { /* private mode or quota - lose the signal, not the upload */ }
  }

  // Which prep phase was running when the page went away. 'probe' points at the
  // size check and decode probe, 'convert' at the worker round trip, 'cards' at
  // card building - three very different fixes, so the distinction is worth
  // carrying.
  function markBuildPhase(phase) {
    try {
      const raw = localStorage.getItem(BUILD_MARKER_KEY);
      if (!raw) return;
      const m = JSON.parse(raw);
      if (m.phase === phase) return;
      m.phase = phase;
      localStorage.setItem(BUILD_MARKER_KEY, JSON.stringify(m));
    } catch (e) { /* no-op */ }
  }

  function markBuildHidden() {
    try {
      const raw = localStorage.getItem(BUILD_MARKER_KEY);
      if (!raw) return;
      const m = JSON.parse(raw);
      if (m.hidden) return;
      m.hidden = 1;
      localStorage.setItem(BUILD_MARKER_KEY, JSON.stringify(m));
    } catch (e) { /* no-op */ }
  }

  function clearBuildMarker() {
    try { localStorage.removeItem(BUILD_MARKER_KEY); } catch (e) { /* no-op */ }
  }

  function reportStaleBuildMarker() {
    try {
      const raw = localStorage.getItem(BUILD_MARKER_KEY);
      if (!raw) return;
      clearBuildMarker();
      const m = JSON.parse(raw);
      const age = Date.now() - (m.t || 0);
      if (!m.t || age > BUILD_MARKER_MAX_AGE_MS) return;
      const phase = m.phase || 'unknown';
      diagCardFailed(
        (m.hidden ? 'page_lost_backgrounded' : 'page_terminated') + '_' + phase, {
          batch_size: m.n || 0,
          client_env: m.env || CLIENT_ENV,
          magnet_shape: m.shape || MAGNET_SHAPE,
          error_detail: phase + ' after ' + Math.round(age / 1000) + 's'
        });
    } catch (e) { /* no-op */ }
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden' && cardWatchdogs.size > 0) {
      markBuildHidden();
    }
  });

  // Deferred so gtag has loaded; a report lost to a race would be worse than
  // one arriving two seconds late.
  setTimeout(reportStaleBuildMarker, 2000);

  // These will be created dynamically when the popup opens
  let cardsInstructionText = null;
  let cardsStatusMessage = null;

  // True while the popup is showing the Converting/Preparing toast. Popup chrome
  // renders independently of the cards container, so it has to be suppressed
  // separately or the footer and the images-below badge show through.
  let prepInProgress = false;
  let prepHiddenEls = [];

  // Get MAX_IMAGES from metafield (dynamic per product)
  // v17: Changed default from 9 to 0 - missing/blank metafield means add-on product
  const MAX_IMAGES = parseInt(uploadBtn.dataset.maxImages) || 0;

  // Rectangle (2x3) support: shape comes from custom.magnet_shape metafield via data-magnet-shape.
  // Blank/missing defaults to 'square' so all existing square products are unaffected.
  const MAGNET_SHAPE = (uploadBtn.dataset.magnetShape || 'square').toLowerCase();
  const IS_RECT = MAGNET_SHAPE === 'rectangle';
  // Aspect ratios for rectangle orientations (width/height). These match the actual
  // picture area of a 2x3 magnet (2.125" x 3.125"), NOT a clean 2:3, so the cropped
  // image drops into the contact-sheet picture zone with no letterboxing or fill.
  const RECT_ASPECT = { portrait: 2.125 / 3.125, landscape: 3.125 / 2.125 };
  // v26: working-resolution cap, applied at the orientation step before any
  // large canvas is allocated. Nothing above this reaches the cutter - output
  // is capped at 1320px (square), 1800px (rectangle) and up to 3960px (3x3
  // mosaic) - so the cap only needs to leave headroom for tight crops.
  //
  // Square and rectangle products accept up to 12 photos, so their peak memory
  // is the cap times the number of cards being built; 4000px keeps that in
  // hand while leaving 3x headroom over a 1320px square output.
  //
  // Mosaics take a SINGLE image and can output 3960px, so a 4000px cap would
  // leave no crop headroom at all. They get 6000px - the peak is one photo,
  // not twelve, so the higher ceiling costs much less than it looks.
  const MAX_WORK_EDGE_DEFAULT = 4000;
  const MAX_WORK_EDGE_MOSAIC = 6000;

  // Modes that show the live cropper (used for low-res checks and default-crop placement).
  // manual-crop = square products; portrait/landscape = rectangle products.
  function isCropperMode(mode) {
    return mode === 'manual-crop' || mode === 'portrait' || mode === 'landscape';
  }

  // ===== MOSAIC (Phase 5) SUPPORT =====
  // Mosaic products split ONE uploaded image across a grid of 2x2 magnets at
  // print time. The uploader's job: single image, exact-aspect crop, grid-aware
  // low-res thresholds, orientation capture (6-Mosaic only), and a live
  // "assembled magnets" seam preview under the cropper.
  // Grid detection is SKU-first via data-product-sku (set in main-product.liquid),
  // consistent with the transporter / analytics / CSC dispatch convention.
  const IS_MOSAIC = MAGNET_SHAPE === 'mosaic';
  const PRODUCT_SKU = (uploadBtn.dataset.productSku || '').trim().toUpperCase();
  const MOSAIC_CONFIG_MAP = {
    // lowRes = minimum crop px before the low-res warning shows. Same per-tile
    // basis as the flat 400px threshold squares use (~200 DPI on a 2" edge),
    // scaled by tiles per axis.
    'TM-MOSAIC-4': { fixedGrid: { cols: 2, rows: 2 }, lowRes: { width: 800,  height: 800  } },
    'TM-MOSAIC-6': { orientations: {
        portrait:  { cols: 2, rows: 3, lowRes: { width: 800,  height: 1200 } },
        landscape: { cols: 3, rows: 2, lowRes: { width: 1200, height: 800  } }
      } },
    'TM-MOSAIC-9': { fixedGrid: { cols: 3, rows: 3 }, lowRes: { width: 1200, height: 1200 } }
  };
  const MOSAIC_CONFIG = IS_MOSAIC ? (MOSAIC_CONFIG_MAP[PRODUCT_SKU] || null) : null;
  if (IS_MOSAIC && !MOSAIC_CONFIG) {
    // Unknown mosaic SKU: fall back to plain single-image square behavior so
    // orders still work; the seam preview and grid thresholds are skipped.
    console.warn('[Mosaic] magnet_shape is mosaic but SKU "' + PRODUCT_SKU + '" is not in MOSAIC_CONFIG_MAP - falling back to square behavior.');
  }
  // 6-Mosaic picks Portrait (2x3) or Landscape (3x2) via the crop-mode dropdown.
  const MOSAIC_HAS_ORIENTATIONS = !!(MOSAIC_CONFIG && MOSAIC_CONFIG.orientations);
  // Mosaic crops use CLEAN ratios (unlike rectangle's 2.125/3.125 picture area):
  // tile picture areas are square, so the assembled aspect is exactly cols:rows.
  const MOSAIC_ASPECT = { portrait: 2 / 3, landscape: 3 / 2 };
  // Resolve the active grid for a crop mode. Fixed-grid products ignore the mode;
  // the 6-Mosaic maps portrait/landscape. Returns null when no grid applies yet.
  function getMosaicGrid(mode) {
    if (!MOSAIC_CONFIG) return null;
    if (MOSAIC_CONFIG.fixedGrid) return MOSAIC_CONFIG.fixedGrid;
    return MOSAIC_CONFIG.orientations[mode] || null;
  }
  // Low-res threshold for the current context. Mosaic thresholds are grid-aware;
  // before the 6-Mosaic orientation is chosen, 800x800 is the floor either
  // orientation requires. Non-mosaic products keep the legacy flat 400.
  function getLowResThreshold(mode) {
    if (MOSAIC_CONFIG) {
      if (MOSAIC_CONFIG.fixedGrid) return MOSAIC_CONFIG.lowRes;
      const o = MOSAIC_CONFIG.orientations[mode];
      return o ? o.lowRes : { width: 800, height: 800 };
    }
    return { width: 400, height: 400 };
  }
  // Instruction slideshow reuse: the 6-Mosaic behaves like rectangle (portrait/
  // landscape cropper), the 4- and 9-Mosaic like square (1:1 cropper). No new
  // slide assets needed.
  function instructionShapeKey() {
    if (IS_RECT || MOSAIC_HAS_ORIENTATIONS) return 'rectangle';
    return 'square';
  }

  // ===== INSTRUCTION SLIDESHOW =====
  // Step-by-step cropping instructions shown at the top of the image cards area.
  // Keyed by magnet shape. An empty array falls back to text-only instructions
  // for that shape.
  const INSTRUCTION_SLIDES = {
    rectangle: [
      { src: 'https://cdn.shopify.com/s/files/1/0648/6209/3510/files/2x3_uploader_step_1.jpg?v=1785781509', caption: "Let's crop your photo" },
      { src: 'https://cdn.shopify.com/s/files/1/0648/6209/3510/files/2x3_uploader_step_2.jpg?v=1785781522', caption: 'The blue box is your magnet' },
      { src: 'https://cdn.shopify.com/s/files/1/0648/6209/3510/files/2x3_uploader_step_3.jpg?v=1785781532', caption: 'Drag corners to zoom in/out' },
      { src: 'https://cdn.shopify.com/s/files/1/0648/6209/3510/files/2x3_uploader_step_4.jpg?v=1785781543', caption: 'Drag inside the box to center' },
      { src: 'https://cdn.shopify.com/s/files/1/0648/6209/3510/files/2x3_uploader_step_5.jpg?v=1785781553', caption: 'Final image for your magnet!' }
    ],
    square: [
      { src: 'https://cdn.shopify.com/s/files/1/0648/6209/3510/files/2x2_uploader_step_1.jpg?v=1785791232', caption: "Let's crop your photo" },
      { src: 'https://cdn.shopify.com/s/files/1/0648/6209/3510/files/2x2_uploader_step_2.jpg?v=1785791242', caption: 'The blue box is your magnet' },
      { src: 'https://cdn.shopify.com/s/files/1/0648/6209/3510/files/2x2_uploader_step_3.jpg?v=1785791254', caption: 'Drag corners to zoom in/out' },
      { src: 'https://cdn.shopify.com/s/files/1/0648/6209/3510/files/2x2_uploader_step_4.jpg?v=1785791263', caption: 'Drag inside the box to center' },
      { src: 'https://cdn.shopify.com/s/files/1/0648/6209/3510/files/2x2_uploader_step_5.jpg?v=1785791678', caption: 'Final image for your magnet!' }
    ]
  };
  // Whether the instruction paragraph renders below the slideshow, per shape.
  // Both shapes rely on the slides alone. The paragraph markup is retained for
  // future products - flip a value to true to bring it back for that shape.
  const SHOW_INSTRUCTION_TEXT = { rectangle: false, square: false };
  // Tip banner shown under the slideshow. Set to '' to hide it.
  const INSTRUCTION_TIP_TEXT = 'Zoom in, avoid empty space around your subject';
  // Dwell time per slide. Scheduled as a self-rescheduling timeout chain rather
  // than setInterval, so each slide gets a full dwell from the moment it becomes
  // visible - main-thread jank during popup build can't coalesce ticks or shift
  // the phase.
  const INSTRUCTION_SLIDE_INTERVAL_MS = 2000;
  const INSTRUCTION_SWIPE_THRESHOLD_PX = 30;
  // Breakpoint at which the desktop static grid replaces the mobile carousel.
  // Must match the min-width used by .instruction-grid in uploader.css.
  const INSTRUCTION_DESKTOP_MIN_WIDTH_PX = 768;
  let instructionSlideTimer = null;
  // Set once the user interacts (arrow tap or swipe) so autoplay never resumes,
  // including after a resize back down to mobile width.
  let instructionAutoplayStopped = false;

  // Builds the instruction slideshow element, or returns null when no slides exist
  // for the current magnet shape. Autoplays every 2s and loops; autoplay stops
  // permanently on the first user interaction (arrow tap or swipe).
  function buildInstructionSlideshow() {
    const slides = INSTRUCTION_SLIDES[instructionShapeKey()] || [];
    if (!slides.length) return null;

    stopInstructionAutoplay();
    instructionAutoplayStopped = false;

    const wrap = document.createElement('div');
    wrap.id = 'instruction-slideshow';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'How to crop your photo');

    const caption = document.createElement('div');
    caption.className = 'instruction-slide-caption';
    caption.setAttribute('aria-live', 'polite');

    const frame = document.createElement('div');
    frame.className = 'instruction-slide-frame';

    const imgs = slides.map((slide, i) => {
      const img = document.createElement('img');
      img.className = 'instruction-slide-img';
      img.src = slide.src;
      img.alt = 'Step ' + (i + 1) + ': ' + slide.caption;
      img.decoding = 'async';
      if (i === 0) img.classList.add('is-active');
      frame.appendChild(img);
      return img;
    });

    // Prev/next arrows, overlaid on the frame so they cost no vertical space.
    // Position within the sequence is conveyed by the numbered caption.
    function makeArrow(direction) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'instruction-slide-arrow instruction-slide-arrow--' + direction;
      btn.setAttribute('aria-label', direction === 'prev' ? 'Previous step' : 'Next step');
      btn.innerHTML = `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
             stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <polyline points="${direction === 'prev' ? '15 18 9 12 15 6' : '9 18 15 12 9 6'}"></polyline>
        </svg>
      `;
      btn.addEventListener('click', () => {
        stopInstructionAutoplay();
        showSlide(current + (direction === 'prev' ? -1 : 1));
      });
      return btn;
    }
    const prevArrow = makeArrow('prev');
    const nextArrow = makeArrow('next');
    frame.appendChild(prevArrow);
    frame.appendChild(nextArrow);

    let current = 0;
    function showSlide(index) {
      current = (index + slides.length) % slides.length;
      imgs.forEach((img, i) => img.classList.toggle('is-active', i === current));
      caption.textContent = (current + 1) + '. ' + slides[current].caption;
    }

    // Swipe support (mobile). Horizontal-dominant gestures only, so vertical
    // scrolling through the popup is never hijacked.
    let touchStartX = 0;
    let touchStartY = 0;
    frame.addEventListener('touchstart', (e) => {
      if (!e.touches || !e.touches.length) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    frame.addEventListener('touchend', (e) => {
      if (!e.changedTouches || !e.changedTouches.length) return;
      const dx = e.changedTouches[0].clientX - touchStartX;
      const dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) < INSTRUCTION_SWIPE_THRESHOLD_PX) return;
      if (Math.abs(dx) <= Math.abs(dy)) return;
      stopInstructionAutoplay();
      showSlide(current + (dx < 0 ? 1 : -1));
    }, { passive: true });

    // Mobile carousel container. Hidden by CSS at desktop widths, where the
    // static grid below takes over.
    const carousel = document.createElement('div');
    carousel.className = 'instruction-carousel';
    carousel.appendChild(caption);
    carousel.appendChild(frame);
    wrap.appendChild(carousel);

    // Desktop static grid - all steps visible at once, no autoplay, no arrows.
    // Hidden by CSS below the desktop breakpoint. Marked aria-hidden because it
    // duplicates the carousel content, which is what screen readers announce.
    const grid = document.createElement('div');
    grid.className = 'instruction-grid';
    grid.setAttribute('aria-hidden', 'true');
    slides.forEach((slide, i) => {
      const item = document.createElement('div');
      item.className = 'instruction-grid-item';

      const gImg = document.createElement('img');
      gImg.className = 'instruction-grid-img';
      gImg.src = slide.src;
      gImg.alt = '';
      gImg.decoding = 'async';

      const gCap = document.createElement('div');
      gCap.className = 'instruction-grid-caption';
      gCap.textContent = (i + 1) + '. ' + slide.caption;

      item.appendChild(gImg);
      item.appendChild(gCap);
      grid.appendChild(item);
    });
    wrap.appendChild(grid);

    // Tip banner - pure HTML/CSS/inline SVG, no image asset
    if (INSTRUCTION_TIP_TEXT) {
      const tip = document.createElement('div');
      tip.className = 'instruction-tip';
      tip.innerHTML = `
        <svg class="instruction-tip-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M9.2 17.2h5.6"/>
          <path d="M10.2 20h3.6"/>
          <path d="M12 4.4a5.4 5.4 0 0 0-3.1 9.8c.5.4.8.9.9 1.5h4.4c.1-.6.4-1.1.9-1.5A5.4 5.4 0 0 0 12 4.4z"/>
          <path d="M12 1.2v1.4"/>
          <path d="M4.5 4.5l1 1"/>
          <path d="M19.5 4.5l-1 1"/>
          <path d="M1.6 12h1.4"/>
          <path d="M21 12h1.4"/>
          <path d="M4.5 19.5l1-1"/>
          <path d="M19.5 19.5l-1-1"/>
        </svg>
        <p class="instruction-tip-text"><strong>Tip:</strong> <span></span></p>
      `;
      tip.querySelector('.instruction-tip-text span').textContent = INSTRUCTION_TIP_TEXT;
      wrap.appendChild(tip);
    }

    showSlide(0);

    const prefersReducedMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const desktopQuery = window.matchMedia
      ? window.matchMedia('(min-width: ' + INSTRUCTION_DESKTOP_MIN_WIDTH_PX + 'px)')
      : null;

    // Teardown detection. buildInstructionSlideshow() returns `wrap` before the
    // caller appends it, so a plain document.body.contains(frame) check would
    // report false on the very first sync and kill autoplay before it starts.
    // Only treat "not in the DOM" as teardown once it has been attached at
    // least once.
    let everAttached = false;
    function isTornDown() {
      if (document.body.contains(frame)) {
        everAttached = true;
        return false;
      }
      return everAttached;
    }

    // Autoplay only runs while the mobile carousel is the visible variant. On
    // desktop the grid shows every step at once, so cycling hidden images would
    // burn cycles for nothing.
    function syncInstructionAutoplay() {
      // Self-cleanup if the popup contents were torn down or rebuilt.
      if (isTornDown()) {
        stopInstructionAutoplay();
        detachDesktopListener();
        return;
      }
      const isDesktop = desktopQuery ? desktopQuery.matches : false;
      if (prefersReducedMotion || isDesktop || instructionAutoplayStopped) {
        if (instructionSlideTimer) {
          clearTimeout(instructionSlideTimer);
          instructionSlideTimer = null;
        }
        return;
      }
      if (instructionSlideTimer) return;
      scheduleNextSlide();
    }

    // One timeout per slide. Re-arms itself after advancing, so the dwell clock
    // restarts on the slide the user is actually looking at.
    function scheduleNextSlide() {
      instructionSlideTimer = setTimeout(() => {
        instructionSlideTimer = null;
        if (isTornDown()) {
          stopInstructionAutoplay();
          detachDesktopListener();
          return;
        }
        // Conditions can change mid-dwell (resize to desktop, user interaction).
        const isDesktopNow = desktopQuery ? desktopQuery.matches : false;
        if (prefersReducedMotion || isDesktopNow || instructionAutoplayStopped) return;
        showSlide(current + 1);
        scheduleNextSlide();
      }, INSTRUCTION_SLIDE_INTERVAL_MS);
    }

    function onDesktopQueryChange() {
      syncInstructionAutoplay();
    }
    function detachDesktopListener() {
      if (!desktopQuery) return;
      if (desktopQuery.removeEventListener) {
        desktopQuery.removeEventListener('change', onDesktopQueryChange);
      } else if (desktopQuery.removeListener) {
        desktopQuery.removeListener(onDesktopQueryChange);
      }
    }
    if (desktopQuery) {
      if (desktopQuery.addEventListener) {
        desktopQuery.addEventListener('change', onDesktopQueryChange);
      } else if (desktopQuery.addListener) {
        desktopQuery.addListener(onDesktopQueryChange);
      }
    }

    // Defer the first schedule until after the popup has painted. Starting it
    // synchronously here would burn part of slide 1's dwell on the card-building
    // work that runs immediately after this function returns.
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(() => syncInstructionAutoplay());
    } else {
      syncInstructionAutoplay();
    }

    return wrap;
  }

  function stopInstructionAutoplay() {
    instructionAutoplayStopped = true;
    if (instructionSlideTimer) {
      clearTimeout(instructionSlideTimer);
      instructionSlideTimer = null;
    }
  }
  
  // v17: Additional guard - if MAX_IMAGES is 0 or less, exit gracefully
  if (MAX_IMAGES <= 0) {
    console.log('Uploader v17: MAX_IMAGES is 0 or less - this is an add-on product. Uploader script exiting.');
    return;
  }
  
  // Get all grid items but only use the number we need
  const allGridItems = document.querySelectorAll('.grid-item');
  const gridItems = Array.from(allGridItems).slice(0, MAX_IMAGES);
  
  // Hide unused grid items
  allGridItems.forEach((item, index) => {
    if (index >= MAX_IMAGES) {
      item.style.display = 'none';
    } else {
      item.style.display = '';
    }
  });

  // Add data attribute to uploader container for CSS targeting
  if (uploaderContainer) {
    uploaderContainer.dataset.maxImages = MAX_IMAGES;
  }

  let imageObjects = [];
  let imageCounter = 0;

  function showMessage(messageBox, message, isError = false, persist = false) {
    if (messageBox) {
      messageBox.style.display = 'block';
      messageBox.textContent = message;
      messageBox.classList.remove('info', 'error');
      messageBox.classList.add(isError ? 'error' : 'info');
      if (!persist) {
        setTimeout(() => {
          messageBox.style.display = 'none';
        }, 3000);
      }
    }
  }
  
  function showToast(message, duration = 3000) {
    // Remove any existing toast
    const existingToast = document.querySelector('.toast-notification');
    if (existingToast) {
      existingToast.remove();
    }
    
    // Create toast element
    const toast = document.createElement('div');
    toast.className = 'toast-notification';
    toast.textContent = message;
    
    // Add to popup content
    const popupContent = document.querySelector('.popup-content');
    if (popupContent) {
      popupContent.appendChild(toast);
      
      // Trigger show animation
      setTimeout(() => {
        toast.classList.add('show');
      }, 10);
      
      // Hide and remove after duration
      setTimeout(() => {
        toast.classList.remove('show');
        setTimeout(() => {
          toast.remove();
        }, 300);
      }, duration);
    }
  }
  
  // Persistent upload progress toast - stays visible until explicitly hidden
  // Also disables interactive elements during upload
  function showUploadProgressToast(message) {
    let toast = document.querySelector('.upload-progress-toast');
    
    // Get the popup-content element
    const popupContent = document.querySelector('.popup-content');
    
    // Create toast if it doesn't exist
    if (!toast && popupContent) {
      toast = document.createElement('div');
      toast.className = 'upload-progress-toast';
      // Position fixed to center on screen
      toast.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background-color:rgba(37,99,235,0.95);color:white;padding:16px 28px;border-radius:8px;font-size:16px;font-weight:600;z-index:100000;box-shadow:0 4px 20px rgba(0,0,0,0.3);text-align:center;';
      popupContent.appendChild(toast);
      
      // Disable interactive elements
      disableUploadInteractions(true);
    }
    
    // Update the message
    if (toast) {
      // On mobile, split at "..." to put "please wait." on its own line
      if (window.innerWidth <= 767 && message.includes('...')) {
        const parts = message.split('...');
        toast.innerHTML = `<span style="white-space:nowrap;">${parts[0]}...</span><br><span style="white-space:nowrap;">${parts[1]}</span>`;
      } else {
        toast.textContent = message;
        toast.style.whiteSpace = 'nowrap';
      }
    }
  }
  
  function hideUploadProgressToast() {
    const toast = document.querySelector('.upload-progress-toast');
    
    if (toast) {
      toast.remove();
    }
    
    // Re-enable interactive elements
    disableUploadInteractions(false);
  }
  
  function disableUploadInteractions(disable) {
    // Disable/enable trash icons
    document.querySelectorAll('.card-trash-icon').forEach(el => {
      el.style.pointerEvents = disable ? 'none' : '';
      el.style.opacity = disable ? '0.5' : '';
    });
    
    // Disable/enable rotate buttons
    document.querySelectorAll('.rotate-btn').forEach(el => {
      el.disabled = disable;
      el.style.pointerEvents = disable ? 'none' : '';
    });
    
    // Disable/enable quantity buttons (cards render these as .qty-btn)
    document.querySelectorAll('.qty-btn').forEach(el => {
      el.disabled = disable;
      el.style.pointerEvents = disable ? 'none' : '';
    });
    
    // Disable/enable crop style dropdowns
    document.querySelectorAll('.crop-mode-select').forEach(el => {
      el.disabled = disable;
      el.style.pointerEvents = disable ? 'none' : '';
    });
    
    // Disable/enable navigation buttons
    document.querySelectorAll('.nav-btn').forEach(el => {
      el.disabled = disable;
      el.style.pointerEvents = disable ? 'none' : '';
    });
    
    // Disable/enable close button. The popup X is .close-btn (the same
    // selector the click handler binds to); .close-popup kept as a fallback
    // in case an alternate template uses it.
    ['.close-btn', '.close-popup'].forEach((sel) => {
      const btn = document.querySelector(sel);
      if (btn) {
        btn.style.pointerEvents = disable ? 'none' : '';
        btn.style.opacity = disable ? '0.5' : '';
      }
    });
  }
  
  function showProductPageToast(message, duration = 4000) {
    // Remove any existing product page toast
    const existingToast = document.querySelector('.product-page-toast');
    if (existingToast) {
      existingToast.remove();
    }
    
    // Create toast element
    const toast = document.createElement('div');
    toast.className = 'product-page-toast';
    
    // On mobile, split sentences into separate lines using spans
    if (window.innerWidth <= 767 && message.includes('. ')) {
      const sentences = message.split('. ');
      toast.innerHTML = sentences.map((s, i) => 
        `<span class="toast-line">${s}${i < sentences.length - 1 ? '.' : ''}</span>`
      ).join('');
    } else {
      toast.textContent = message;
    }
    
    // Add to body
    document.body.appendChild(toast);
    
    // Trigger show animation
    setTimeout(() => {
      toast.classList.add('show');
    }, 10);
    
    // Hide and remove after duration
    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => {
        toast.remove();
      }, 300);
    }, duration);
  }
  
  function updateBothStatusMessages(message, isError = false, persist = false) {
    dlog('=== updateBothStatusMessages called ===');
    dlog('Message:', message);
    
    // Update sticky footer message
    if (uploadStatusMessage) {
      dlog('Updating uploadStatusMessage');
      showMessage(uploadStatusMessage, message, isError, persist);
    } else {
      console.warn('uploadStatusMessage is null/undefined');
    }
    
    // Update cards status message (below cards in scrollable area)
    if (cardsStatusMessage) {
      dlog('Updating cardsStatusMessage');
      showMessage(cardsStatusMessage, message, isError, persist);
    } else {
      console.warn('cardsStatusMessage is null/undefined - will be created when popup opens');
    }
  }
  
  function updateStickyFooterOnly(message, isError = false, persist = false) {
    // Only update the sticky footer message, not the scrollable area message
    if (uploadStatusMessage) {
      showMessage(uploadStatusMessage, message, isError, persist);
    }
  }
  
  function getGridImageCount() {
    let count = 0;
    gridItems.forEach(item => {
      const img = item.querySelector('img');
      if (img) {
        count++;
      }
    });
    return count;
  }

  function updateAddToCartButtonState() {
    if (addToCartBtn) {
      const currentCount = getGridImageCount();
      const shouldEnable = (currentCount === MAX_IMAGES);
      addToCartBtn.disabled = !shouldEnable;
    }
  }

  function updateUploadButtonVisibility() {
    const currentCount = getGridImageCount();
    uploadBtn.style.display = currentCount === MAX_IMAGES ? 'none' : 'block';
  }

  function updateUploadButtonText() {
    const currentCount = getGridImageCount();
    if (currentCount === MAX_IMAGES) {
      uploadBtn.textContent = 'Replace All Images';
    } else {
      if (MAX_IMAGES === 1) {
        uploadBtn.textContent = 'Upload Image';
      } else {
        uploadBtn.textContent = 'Upload Images';
      }
    }
  }

  function updateSaveAllButtonState() {
    // Check if all crop mode selects have a value other than "select-one"
    const allCropModeSelects = document.querySelectorAll('.crop-mode-select');
    let allSelected = true;
    
    allCropModeSelects.forEach(select => {
      if (select.value === 'select-one') {
        allSelected = false;
      }
    });
    
    if (saveAllBtn) {
      saveAllBtn.disabled = !allSelected;
    }
  }

  function updateCropSelectionStatus() {
    // Find all image cards and check which ones need crop type selected
    const imageCards = document.querySelectorAll('.image-card');
    const unselectedPhotos = [];
    
    imageCards.forEach((card, index) => {
      const cropModeSelect = card.querySelector('.crop-mode-select');
      if (cropModeSelect && cropModeSelect.value === 'select-one') {
        // Store the photo number (index + 1)
        unselectedPhotos.push(index + 1);
      }
    });
    
    // Generate the message
    let message = '';
    if (unselectedPhotos.length === 0) {
      // All photos have crop type selected
      message = 'All images are ready to upload!';
      
      // Show toast on mobile only
      if (window.innerWidth <= 767) {
        showToast(message);
      }
    } else if (unselectedPhotos.length === 1) {
      // Single photo needs selection
      message = 'One image needs a crop style selected.';
    } else {
      // Multiple photos need selection
      message = 'Select a crop style for each image.';
    }
    
    // Update ONLY the sticky footer status message, not the scrollable area message
    updateStickyFooterOnly(message, false, true);
    
    // Update the floating badge for images below
    updateImagesBelowBadge();
  }

  // Floating badge showing how many unselected images are below the viewport
  function updateImagesBelowBadge() {
    // Nothing is visible to scroll past yet, and the badge would sit on top of
    // the prep toast.
    if (prepInProgress) return;

    const scrollableContainer = document.getElementById('image-cards-container');
    if (!scrollableContainer) return;
    
    let badge = document.querySelector('.images-below-badge');
    
    // Get all image cards that still need selection
    const imageCards = document.querySelectorAll('.image-card');
    let unselectedBelowCount = 0;
    
    const containerRect = scrollableContainer.getBoundingClientRect();
    
    imageCards.forEach((card) => {
      const cropModeSelect = card.querySelector('.crop-mode-select');
      const cardRect = card.getBoundingClientRect();
      const isUnselected = cropModeSelect && cropModeSelect.value === 'select-one';
      
      // Check if the card's dropdown area is below the viewport
      const cardTopThird = cardRect.top + (cardRect.height / 3);
      const isBelow = cardTopThird > containerRect.bottom;
      
      if (isUnselected && isBelow) {
        unselectedBelowCount++;
      }
    });
    
    // Create badge if it doesn't exist
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'images-below-badge';
      
      // Make badge clickable - scroll to next unselected image
      badge.addEventListener('click', () => {
        scrollToFirstCardNeedingSelection();
      });
      
      const popupContent = document.querySelector('.popup-content');
      if (popupContent) {
        popupContent.appendChild(badge);
      }
    }
    
    // Update badge visibility and content
    if (unselectedBelowCount > 0) {
      const imageWord = unselectedBelowCount === 1 ? 'image' : 'images';
      badge.innerHTML = `
        <span>${unselectedBelowCount} more ${imageWord} below</span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      `;
      badge.style.display = 'flex';
    } else {
      badge.style.display = 'none';
    }
  }

  // Setup scroll listener for the badge
  function setupImagesBelowBadgeListener() {
    const scrollableContainer = document.getElementById('image-cards-container');
    if (!scrollableContainer) return;
    
    // Debounce scroll updates
    let scrollTimeout;
    scrollableContainer.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateImagesBelowBadge, 100);
    });
    
    // Also call it immediately after a short delay to catch initial state
    setTimeout(updateImagesBelowBadge, 500);
  }

  function updateNextButtonState(card) {
    // Update the Next button state based on whether crop mode is selected
    const cropModeSelect = card.querySelector('.crop-mode-select');
    const nextBtn = card.querySelector('.nav-btn-next');
    
    if (!nextBtn || !cropModeSelect) return;
    
    const isSelected = cropModeSelect.value !== 'select-one';
    
    if (isSelected) {
      nextBtn.disabled = false;
      nextBtn.classList.remove('disabled');
    } else {
      nextBtn.disabled = true;
      nextBtn.classList.add('disabled');
    }
  }

  function getTotalQuantityInPopup() {
    // Get total quantity of all image cards in the popup
    const imageCards = document.querySelectorAll('.image-card');
    let total = 0;
    imageCards.forEach(card => {
      const qty = parseInt(card.dataset.quantity) || 1;
      total += qty;
    });
    return total;
  }

  function getRemainingSlots() {
    // Calculate remaining slots available
    const gridCount = getGridImageCount();
    const popupTotal = getTotalQuantityInPopup();
    return MAX_IMAGES - gridCount - popupTotal;
  }

  function updateAllCardTitles() {
    // Update all card titles to reflect cumulative quantities
    const imageCards = document.querySelectorAll('.image-card');
    const gridCount = getGridImageCount();
    let runningPosition = gridCount;
    
    imageCards.forEach((card) => {
      const qty = parseInt(card.dataset.quantity) || 1;
      const h4 = card.querySelector('.card-header h4');
      
      if (h4 && MAX_IMAGES !== 1) {
        const startPos = runningPosition + 1;
        const endPos = runningPosition + qty;
        
        if (qty === 1) {
          h4.textContent = `${startPos} of ${MAX_IMAGES}`;
        } else {
          h4.textContent = `${startPos}-${endPos} of ${MAX_IMAGES}`;
        }
        
        runningPosition = endPos;
      }
    });
  }

  function updateAllQuantityButtons() {
    // Update +/- button states based on remaining slots
    const imageCards = document.querySelectorAll('.image-card');
    const remainingSlots = getRemainingSlots();
    
    imageCards.forEach(card => {
      const qty = parseInt(card.dataset.quantity) || 1;
      const minusBtn = card.querySelector('.qty-minus');
      const plusBtn = card.querySelector('.qty-plus');
      
      if (minusBtn) {
        // Disable minus if qty is 1
        minusBtn.disabled = qty <= 1;
      }
      
      if (plusBtn) {
        // Disable plus if no remaining slots
        plusBtn.disabled = remainingSlots <= 0;
      }
    });
  }

  // ===== MOSAIC SEAM PREVIEW =====
  // Live "assembled magnets" preview rendered under the cropper on mosaic
  // products: the current crop is split into the product grid and each tile is
  // drawn as a separate magnet with a physical gap, so the customer sees where
  // the seams fall BEFORE ordering. Re-renders (debounced) on every crop change.
  // Bevel overlay: when the transparent bevel PNG asset exists, set
  // MOSAIC_BEVEL_SRC to its CDN URL and it is composited over each tile. Until
  // then, a drawn fallback (rounded corners, drop shadow, edge shading)
  // approximates the magnet face.
  const MOSAIC_BEVEL_SRC = ''; // e.g. 'https://cdn.shopify.com/s/files/.../mosaic_tile_bevel.png'
  // Preview tuning knobs:
  // - corner radius as a fraction of tile size (first build was 0.055; 0 = square)
  // - seam stroke width = max(1, tile * 0.006) + MOSAIC_SEAM_EXTRA_PX per tile edge
  const MOSAIC_CORNER_RADIUS_FRAC = 0.02;
  const MOSAIC_SEAM_EXTRA_PX = 0;
  let mosaicBevelImg = null;
  let mosaicBevelLoadTried = false;
  function ensureMosaicBevelImage() {
    if (!MOSAIC_BEVEL_SRC || mosaicBevelLoadTried) return;
    mosaicBevelLoadTried = true;
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => { mosaicBevelImg = img; };
    img.onerror = () => { console.warn('[Mosaic] Bevel overlay failed to load; using drawn fallback.'); };
    img.src = MOSAIC_BEVEL_SRC;
  }

  // Preview visibility plus its companion UI: the mobile "scroll down" hint
  // and the desktop side-by-side card layout (CSS keys off the
  // .mosaic-side-by-side class at >=800px) both follow the preview's state.
  function setMosaicPreviewVisible(card, wrap, visible) {
    wrap.style.display = visible ? 'block' : 'none';
    const hint = card.querySelector('.mosaic-preview-hint');
    if (hint) hint.classList.toggle('is-visible', visible);
    card.classList.toggle('mosaic-side-by-side', visible);
  }

  // The hint is a button (styled like the Next Image nav button) that scrolls
  // the preview into view. Delegated once; the button only exists on mosaic cards.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.mosaic-preview-hint');
    if (!btn) return;
    const card = btn.closest('.image-card');
    const wrap = card && card.querySelector('.mosaic-preview');
    if (wrap && wrap.style.display !== 'none') {
      wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  const mosaicPreviewTimers = {};
  function scheduleMosaicPreview(card) {
    if (!MOSAIC_CONFIG) return;
    const id = card.dataset.id || 'card';
    clearTimeout(mosaicPreviewTimers[id]);
    mosaicPreviewTimers[id] = setTimeout(() => renderMosaicPreview(card), 150);
  }

  function renderMosaicPreview(card) {
    if (!MOSAIC_CONFIG) return;
    const wrap = card.querySelector('.mosaic-preview');
    if (!wrap) return;
    const obj = imageObjects.find(o => o.card === card);
    const modeSelect = card.querySelector('.crop-mode-select');
    const mode = modeSelect ? modeSelect.value : '';
    const grid = getMosaicGrid(mode);
    if (!obj || !obj.cropper || !isCropperMode(mode) || !grid) {
      setMosaicPreviewVisible(card, wrap, false);
      return;
    }
    let srcCanvas = null;
    try {
      srcCanvas = obj.cropper.getCroppedCanvas({ maxWidth: 900, maxHeight: 900 });
    } catch (e) { /* cropper mid-transition; the next crop event re-schedules */ }
    if (!srcCanvas || !srcCanvas.width || !srcCanvas.height) {
      setMosaicPreviewVisible(card, wrap, false);
      return;
    }
    ensureMosaicBevelImage();
    setMosaicPreviewVisible(card, wrap, true);

    const canvas = wrap.querySelector('.mosaic-preview-canvas');
    const cols = grid.cols, rows = grid.rows;
    // Display geometry: tiles sit FLUSH against each other (magnets assembled
    // edge-to-edge on the fridge), with a small outer margin so the block-level
    // drop shadow isn't clipped. Seams read via the per-tile black edges.
    const availWidth = Math.max((wrap.clientWidth || 300) - 24, 200); // minus panel padding
    const margin = 12;
    let tile = (availWidth - 2 * margin) / cols;
    // Desktop side-by-side: portrait grids (rows > cols) are capped to the
    // HEIGHT a landscape grid renders at this width, so the 2x3 preview doesn't
    // stretch the card downward. Square and landscape grids are width-driven.
    if (rows > cols && window.matchMedia && window.matchMedia('(min-width: 800px)').matches) {
      // Cap = fraction of the available content width. 1.0 makes the portrait
      // preview as tall as a square preview would be; 2/3 would match landscape
      // exactly (too small in practice).
      const MOSAIC_PORTRAIT_MAX_HEIGHT_FRAC = 1.0;
      const maxContentH = (availWidth - 2 * margin) * MOSAIC_PORTRAIT_MAX_HEIGHT_FRAC;
      tile = Math.min(tile, maxContentH / rows);
    }
    const cssWidth = cols * tile + 2 * margin;
    const cssHeight = rows * tile + 2 * margin;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(cssWidth * dpr);
    canvas.height = Math.round(cssHeight * dpr);
    canvas.style.width = cssWidth + 'px';
    canvas.style.height = cssHeight + 'px';
    const ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    // Fridge-like backdrop behind the tiles
    ctx.fillStyle = '#e8eaed';
    ctx.fillRect(0, 0, cssWidth, cssHeight);

    const tileSrcW = srcCanvas.width / cols;
    const tileSrcH = srcCanvas.height / rows;
    const blockW = cols * tile;
    const blockH = rows * tile;

    // Black underlay + one drop shadow for the assembled block. The underlay is
    // what shows through at the slightly-rounded corner junctions - the extra
    // black where four magnets meet, matching the real product.
    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,0.28)';
    ctx.shadowBlur = tile * 0.05;
    ctx.shadowOffsetY = tile * 0.02;
    ctx.fillStyle = '#000000';
    ctx.fillRect(margin, margin, blockW, blockH);
    ctx.restore();

    const radius = tile * MOSAIC_CORNER_RADIUS_FRAC;
    const lw = Math.max(1, tile * 0.006) + MOSAIC_SEAM_EXTRA_PX;

    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) {
        const x = margin + c * tile;
        const y = margin + r * tile;
        ctx.save();
        drawMosaicRoundedRect(ctx, x, y, tile, tile, radius);
        ctx.clip();
        ctx.drawImage(srcCanvas, c * tileSrcW, r * tileSrcH, tileSrcW, tileSrcH, x, y, tile, tile);
        if (mosaicBevelImg) {
          // Real bevel asset composited over the tile
          ctx.drawImage(mosaicBevelImg, x, y, tile, tile);
        } else {
          // Pure black edge on every tile: adjacent tiles' edges merge into the
          // solid black seam of the assembled magnets.
          ctx.lineWidth = lw;
          ctx.strokeStyle = '#000000';
          drawMosaicRoundedRect(ctx, x, y, tile, tile, radius);
          ctx.stroke();
        }
        ctx.restore();
      }
    }
  }

  function drawMosaicRoundedRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    if (r <= 0) { ctx.rect(x, y, w, h); return; }
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  function updateLowResWarning(card, cropper, originalWidth, originalHeight, cropMode) {
    const lowResWarning = card.querySelector('.low-res-warning');
    const blurWarning = card.querySelector('.blur-warning');
    if (!lowResWarning) return;
    
    // Grid-aware thresholds for mosaic products; legacy flat 400 elsewhere.
    const TH = getLowResThreshold(cropMode);
    let showLowRes = false;
    
    if (isCropperMode(cropMode) && cropper) {
      // For manual crop / orientation modes, check the actual cropped dimensions
      const cropData = cropper.getData();
      if (cropData && cropData.width > 0 && cropData.height > 0) {
        showLowRes = cropData.width < TH.width || cropData.height < TH.height;
      }
    } else {
      // For entire image modes or select-one, check original dimensions
      showLowRes = originalWidth < TH.width || originalHeight < TH.height;
    }
    
    lowResWarning.style.display = showLowRes ? 'block' : 'none';
    
    // Manage blur warning visibility (low-res takes priority)
    if (blurWarning) {
      const obj = imageObjects.find(o => o.card === card);
      const isBlurry = obj && obj.isBlurry;
      // Show blur warning only if image is blurry AND low-res is NOT shown
      blurWarning.style.display = (isBlurry && !showLowRes) ? 'block' : 'none';
    }
  }

  // Blur detection using Laplacian variance
  function detectBlur(imageElement) {
    return new Promise((resolve) => {
      // Helper function to run the actual detection
      const runDetection = () => {
        try {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          
          // Downsample for performance (max 200px on longest side)
          const maxSize = 200;
          const scale = Math.min(maxSize / imageElement.naturalWidth, maxSize / imageElement.naturalHeight, 1);
          const width = Math.floor(imageElement.naturalWidth * scale);
          const height = Math.floor(imageElement.naturalHeight * scale);
          
          // Check for valid dimensions
          if (width <= 2 || height <= 2) {
            console.warn('[BlurDetect] Image too small for blur detection');
            resolve({ isBlurry: false, variance: 0 });
            return;
          }
          
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(imageElement, 0, 0, width, height);
          
          const imageData = ctx.getImageData(0, 0, width, height);
          const data = imageData.data;
          
          // Convert to grayscale
          const gray = new Float32Array(width * height);
          for (let i = 0; i < width * height; i++) {
            const idx = i * 4;
            gray[i] = 0.299 * data[idx] + 0.587 * data[idx + 1] + 0.114 * data[idx + 2];
          }
          
          // Apply Laplacian kernel: [0, 1, 0], [1, -4, 1], [0, 1, 0]
          const laplacian = new Float32Array(width * height);
          for (let y = 1; y < height - 1; y++) {
            for (let x = 1; x < width - 1; x++) {
              const idx = y * width + x;
              laplacian[idx] = 
                gray[idx - width] +           // top
                gray[idx - 1] +               // left
                gray[idx + 1] +               // right
                gray[idx + width] -           // bottom
                4 * gray[idx];                // center
            }
          }
          
          // Calculate variance of Laplacian
          let sum = 0;
          let sumSq = 0;
          let count = 0;
          
          for (let y = 1; y < height - 1; y++) {
            for (let x = 1; x < width - 1; x++) {
              const val = laplacian[y * width + x];
              sum += val;
              sumSq += val * val;
              count++;
            }
          }
          
          const mean = sum / count;
          const variance = (sumSq / count) - (mean * mean);
          
          dlog(`[BlurDetect] Laplacian variance: ${variance.toFixed(2)}`);
          
          // Threshold for blur detection (lower = more blurry)
          // Typical values: sharp image > 700, blurry < 500
          const BLUR_THRESHOLD = 500;
          const isBlurry = variance < BLUR_THRESHOLD;
          
          resolve({ isBlurry, variance });
        } catch (error) {
          console.warn('[BlurDetect] Error:', error.message);
          resolve({ isBlurry: false, variance: 0 });
        }
      };
      
      // Check if image is already loaded
      if (imageElement.complete && imageElement.naturalWidth > 0) {
        runDetection();
      } else {
        // Wait for image to load
        imageElement.addEventListener('load', runDetection, { once: true });
        imageElement.addEventListener('error', () => {
          console.warn('[BlurDetect] Image failed to load');
          resolve({ isBlurry: false, variance: 0 });
        }, { once: true });
      }
    });
  }

  function updateBlurWarning(card, isBlurry) {
    const blurWarning = card.querySelector('.blur-warning');
    const lowResWarning = card.querySelector('.low-res-warning');
    if (!blurWarning) return;
    
    // Only show blur warning if low-res warning is NOT shown (low-res takes priority)
    const lowResVisible = lowResWarning && lowResWarning.style.display !== 'none';
    blurWarning.style.display = (isBlurry && !lowResVisible) ? 'block' : 'none';
  }

  // Scroll to the first card that needs a crop style selection
  function scrollToFirstCardNeedingSelection() {
    const imageCards = document.querySelectorAll('.image-card');
    
    for (const card of imageCards) {
      const select = card.querySelector('.crop-mode-select');
      if (select && select.value === 'select-one') {
        // Found a card that needs selection - scroll to it
        card.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    
    // If all cards have selections, scroll to the first card
    if (imageCards.length > 0) {
      imageCards[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function setupCardNavigation() {
    const imageCards = document.querySelectorAll('.image-card');
    const totalCards = imageCards.length;
    
    // If only one card, hide all navigation buttons
    if (totalCards <= 1) {
      imageCards.forEach(card => {
        const navButtons = card.querySelector('.card-navigation-buttons');
        if (navButtons) navButtons.style.display = 'none';
      });
      return;
    }
    
    // Setup click handlers for all navigation buttons
    imageCards.forEach((card, index) => {
      const prevBtn = card.querySelector('.nav-btn-prev');
      const nextBtn = card.querySelector('.nav-btn-next');
      
      // Hide prev button on first card
      if (index === 0 && prevBtn) {
        prevBtn.style.display = 'none';
      }
      
      // Hide next button on last card
      if (index === totalCards - 1 && nextBtn) {
        nextBtn.style.display = 'none';
      }
      
      // Set initial Next button state (disabled until crop mode selected)
      updateNextButtonState(card);
      
      // Previous button click handler
      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          if (index > 0) {
            const prevCard = imageCards[index - 1];
            prevCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
      
      // Next button click handler
      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          // Don't proceed if button is disabled
          if (nextBtn.disabled) return;
          
          if (index < totalCards - 1) {
            const nextCard = imageCards[index + 1];
            nextCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
    });
  }

  function updateGuidanceMessage() {
    const currentCount = getGridImageCount();
    let message = '';
    
    if (currentCount === 0) {
      // No images uploaded yet - guide user to start
      if (MAX_IMAGES === 1) {
        message = 'Upload your image to start.';
      } else if (MAX_IMAGES === 9) {
        message = 'Upload your 9 images to start.';
      } else if (MAX_IMAGES === 12) {
        message = 'Upload your 12 images to start.';
      } else {
        // Fallback for other numbers
        message = `Upload your ${MAX_IMAGES} images to start.`;
      }
    } else if (currentCount < MAX_IMAGES) {
      // Some images uploaded but not all - tell user how many more needed
      const remaining = MAX_IMAGES - currentCount;
      
      if (MAX_IMAGES === 1) {
        // No intermediate message for 1 image product (can't have between 0 and 1)
        message = '';
      } else {
        // Calculate and display remaining images needed
        const imageWord = remaining === 1 ? 'image' : 'images';
        message = `Upload ${remaining} more ${imageWord}.<br>Tap/Click an image to remove it.`;
      }
    } else if (currentCount === MAX_IMAGES) {
      // All required images uploaded - user can add to cart
      message = 'Tap/Click an image to remove it.';
      if (MAX_IMAGES === 1) {
        showProductPageToast('Upload complete. You may Add to cart now.');
      } else {
        showProductPageToast(`All ${MAX_IMAGES} images are uploaded. You may Add to cart now.`);
      }
    }
    
    if (message) {
      mainMessageBox.style.display = 'block';
      mainMessageBox.innerHTML = message; // Changed from textContent to innerHTML to support <br> tags
      mainMessageBox.classList.remove('error');
      mainMessageBox.classList.add('info');
    } else {
      mainMessageBox.style.display = 'none';
    }
  }

  // v26: an object URL pins its file until revoked. Released whenever an image
  // object is discarded. A missed release leaks a short string and a file
  // handle, not a 20MB buffer, so this is a tidiness measure rather than a
  // load-bearing one - but a customer who selects and clears repeatedly would
  // otherwise accumulate them for the life of the page.
  function releaseSourceURL(obj) {
    try {
      if (obj && obj.srcObjectURL) {
        URL.revokeObjectURL(obj.srcObjectURL);
        obj.srcObjectURL = null;
      }
    } catch (e) { /* revoking twice is harmless */ }
  }

  function releaseAllSourceURLs() {
    try {
      imageObjects.forEach(releaseSourceURL);
    } catch (e) { /* never block a teardown on cleanup */ }
  }

  function clearAllImages() {
    gridItems.forEach(item => {
      item.innerHTML = '';
    });
    imageGrid.style.display = 'none';
    updateR2UrlsInput();
    updateGuidanceMessage();
    updateAddToCartButtonState();
    updateUploadButtonText();
    updateUploadButtonVisibility();
  }

  function createUniqueId() {
    return `img-${imageCounter++}`;
  }

  function updateR2UrlsInput() {
    const r2UrlsInput = document.querySelector('input[name="properties[__r2_image_urls]"]') || 
                        document.querySelector('#r2-image-urls');
    
    if (!r2UrlsInput) {
      console.warn('Could not find R2 URLs input field');
      return;
    }

    const imageUrls = [];
    gridItems.forEach(item => {
      const img = item.querySelector('img');
      if (img && img.dataset.url) {
        imageUrls.push(img.dataset.url);
      }
    });
    
    r2UrlsInput.value = imageUrls.join(',');
    
    dlog('Updated R2 URLs input:', r2UrlsInput.value);
    dlog('Input element:', r2UrlsInput);
    
    updateMosaicOrientationInput();
  }

  // 6-Mosaic only: mirror the chosen orientation into properties[__mosaic_orientation]
  // (hidden input in buy-buttons.liquid, rendered only on mosaic products) so the
  // order payload carries it explicitly. Reads from the grid image's dataset - the
  // same lifecycle as the R2 URLs. Upload, removal, and clear-all all pass through
  // updateR2UrlsInput, so this stays in sync with no extra call sites.
  function updateMosaicOrientationInput() {
    const input = document.querySelector('input[name="properties[__mosaic_orientation]"]') ||
                  document.querySelector('#mosaic-orientation');
    if (!input) return;
    let orientation = '';
    gridItems.forEach(item => {
      const img = item.querySelector('img');
      if (img && img.dataset.mosaicOrientation) orientation = img.dataset.mosaicOrientation;
    });
    input.value = orientation;
    dlog('Updated mosaic orientation input:', orientation);
  }

  function updateBackground(imageCard) {
    const imageContainer = imageCard.querySelector('.image-container');
    const cropModeSelect = imageCard.querySelector('.crop-mode-select');
    if (!imageContainer || !cropModeSelect) {
      console.error('Required elements not found in image card.');
      return;
    }
    
    const mode = cropModeSelect.value;
    if (mode === 'entire-white') {
      // White background
      imageContainer.style.backgroundColor = '#fff';
      imageContainer.style.backgroundImage = 'none';
    } else if (mode === 'entire-black') {
      // Black background
      imageContainer.style.backgroundColor = '#000';
      imageContainer.style.backgroundImage = 'none';
    } else {
      // Checkered pattern for "Select One" and "Manual Crop"
      imageContainer.style.backgroundColor = '#ccc';
      imageContainer.style.backgroundImage = `
        linear-gradient(45deg, #999 25%, transparent 25%),
        linear-gradient(-45deg, #999 25%, transparent 25%),
        linear-gradient(45deg, transparent 75%, #999 75%),
        linear-gradient(-45deg, transparent 75%, #999 75%)
      `;
      imageContainer.style.backgroundSize = '20px 20px';
      imageContainer.style.backgroundPosition = '0 0, 0 10px, 10px -10px, -10px 0px';
    }
  }

  function updateBorderColor(imageCard) {
    const imageContainer = imageCard.querySelector('.image-container');
    const cropModeSelect = imageCard.querySelector('.crop-mode-select');
    
    if (!imageContainer || !cropModeSelect) return;
    
    const mode = cropModeSelect.value;
    if (mode === 'entire-black' || mode === 'entire-white') {
      setTimeout(() => {
        imageContainer.classList.add('entire-image-on');
      }, 100);
    } else {
      imageContainer.classList.remove('entire-image-on');
    }
  }
  
  async function uploadImageToCloudflare(blob, uniqueId) {
    dlog('Simulating upload of cropped image to Cloudflare...');
    dlog('Blob size:', blob.size);
    dlog('Blob type:', blob.type);
    dlog('Unique ID:', uniqueId);

    return new Promise(resolve => {
      setTimeout(() => {
        resolve(`https://your-r2-bucket.cloudflare.com/${uniqueId}.png`);
      }, 1000);
    });
  }
  
  function getImageOrientation(file, callback) {
    const reader = new FileReader();
    reader.onload = (e) => {
      const view = new DataView(e.target.result);
      if (view.getUint16(0, false) !== 0xFFD8) return callback(-2);
      let length = view.byteLength, offset = 2;
      while (offset < length) {
        if (view.getUint16(offset + 2, false) <= 8) return callback(-1);
        let marker = view.getUint16(offset, false);
        offset += 2;
        if (marker === 0xFFE1) {
          if (view.getUint32(offset += 2, false) !== 0x45786966) return callback(-1);
          let little = view.getUint16(offset += 6, false) === 0x4949;
          offset += view.getUint32(offset + 4, little);
          let tags = view.getUint16(offset, little);
          offset += 2;
          for (let i = 0; i < tags; i++)
            if (view.getUint16(offset + (i * 12), little) === 0x0112) {
              return callback(view.getUint16(offset + (i * 12) + 8, little));
            }
        } else if ((marker & 0xFF00) !== 0xFF00) break;
        else offset += view.getUint16(offset, false);
      }
      return callback(-1);
    };
    reader.readAsArrayBuffer(file.slice(0, 64 * 1024));
  }

  // v25: takes an optional diagCtx purely so a failure here can be attributed
  // to a photo position, size and resolution in GA4. Behaviour is unchanged -
  // a toDataURL that throws still rejects the promise, so the caller's existing
  // "use the original image" fallback still runs exactly as before.
  function applyOrientation(img, orientation, diagCtx) {
    return new Promise((resolve) => {
      const diagT0 = Date.now();
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      let width = img.naturalWidth;
      let height = img.naturalHeight;

      // v26: downscale HERE, before the canvas is sized. Everything downstream
      // - the canvas, the JPEG encode, the string it produces, and the browser's
      // second decode of that string for display - shrinks with it. drawImage
      // below already takes width/height as its destination size, so the scale
      // happens in one GPU operation with no extra allocation.
      const workCap = MOSAIC_CONFIG ? MAX_WORK_EDGE_MOSAIC : MAX_WORK_EDGE_DEFAULT;
      const workLongEdge = Math.max(width, height);
      if (workLongEdge > workCap) {
        const workScale = workCap / workLongEdge;
        width = Math.max(1, Math.round(width * workScale));
        height = Math.max(1, Math.round(height * workScale));
      }

      if ([5, 6, 7, 8].includes(orientation)) {
        canvas.width = height;
        canvas.height = width;
      } else {
        canvas.width = width;
        canvas.height = height;
      }

      switch (orientation) {
        case 2: ctx.transform(-1, 0, 0, 1, width, 0); break;
        case 3: ctx.rotate(Math.PI); ctx.translate(-width, -height); break;
        case 4: ctx.transform(1, 0, 0, -1, 0, height); break;
        case 5: ctx.rotate(Math.PI / 2); ctx.scale(-1, 1); break;
        case 6: ctx.rotate(Math.PI / 2); ctx.translate(0, -height); break;
        case 7: ctx.rotate(-Math.PI / 2); ctx.scale(-1, 1); break;
        case 8: ctx.rotate(-Math.PI / 2); ctx.translate(-width, 0); break;
        default: break;
      }

      ctx.drawImage(img, 0, 0, width, height);

      // ---- v25 diagnostics ------------------------------------------------
      // This is where a memory-starved browser silently produces nothing.
      // image_px stays the ORIGINAL resolution so before/after runs stay
      // comparable; canvas_px is what v26 actually allocated.
      const diagBase = Object.assign({
        canvas_px: diagMpBucket(canvas.width, canvas.height)
      }, diagCtx || {});
      const diagState = diagCanvasState(canvas);
      let diagURL = '';
      let diagEncodeErr = '';
      try {
        diagURL = canvas.toDataURL('image/jpeg');
      } catch (err) {
        diagEncodeErr = (err && err.name) || 'error';
      }
      const diagMs = Date.now() - diagT0;

      if (diagState === 'blank') {
        diagCardFailed('orientation_blank_canvas',
          Object.assign({ orient_ms: diagMs }, diagBase));
      } else if (diagEncodeErr) {
        diagCardFailed('orientation_encode_error',
          Object.assign({ orient_ms: diagMs, error_detail: diagEncodeErr }, diagBase));
      } else if (!diagURL || diagURL.length < 1000) {
        diagCardFailed('orientation_encode_empty',
          Object.assign({ orient_ms: diagMs, error_detail: String(diagURL.length) }, diagBase));
      } else if (diagState === 'uniform') {
        diagCardFailed('orientation_uniform_canvas',
          Object.assign({ orient_ms: diagMs }, diagBase));
      }

      // Preserve the original contract: an encode failure rejects, so the
      // caller falls back to the untouched original exactly as it did in v24.
      if (diagEncodeErr) throw new Error('toDataURL failed: ' + diagEncodeErr);
      // ---------------------------------------------------------------------

      resolve(diagURL);
    });
  }

  // ==========================================================================
  // IMAGE NORMALIZATION (HEIC / undecodable formats)
  // --------------------------------------------------------------------------
  // Chrome, Edge and Firefox have no HEIC decoder, so an iPhone .heic file that
  // reaches `img.src` fires onerror and renders an empty card. Roughly a third
  // of traffic is on a browser in that position.
  //
  // Rather than sniff the file extension, we probe whether THIS browser can
  // actually decode THIS file. Safari decodes HEIC natively and costs nothing;
  // everyone else routes to the conversion Worker. The probe also catches
  // truncated and corrupt files of any format.
  //
  // Everything downstream consumes a File object, so a converted File drops
  // into the existing pipeline (orientation, blur detect, Cropper,
  // upload) with no other changes. Square and rectangle behave identically:
  // crop aspect comes from the mode dropdown, never from the source file.
  // ==========================================================================

  const CONVERT_API_URL = 'https://uploader-image-convert-api.mark-hatlan.workers.dev/';
  // v27: 20MB, matching uploader-image-convert-api v1.1.0. This is the Images
  // binding's own hard ceiling, so there is no headroom above it. MUST stay in
  // step with MAX_INPUT_BYTES in the worker - the two are checked
  // independently, and the client check is what produces the readable message.
  const CONVERT_MAX_BYTES = 20 * 1024 * 1024;  // must match the Worker's cap
  const CONVERT_CONCURRENCY = 3;               // conversion runs ~1-4s per file
  const PROBE_CONCURRENCY = 3;                 // decode probe is local but not free
  // v27: 30s -> 90s. The clock covers UPLOAD TRANSMISSION plus conversion, not
  // just conversion. The worker's own processing is 1.5-2.5s; the rest is the
  // customer's uplink. Raising the cap to 20MB made the worst-case payload four
  // times bigger, and CONVERT_CONCURRENCY of 3 means three of them share the
  // same connection - so a 20MB file on a weak mobile uplink can legitimately
  // need well over a minute. At 30s those would have failed as worker_timeout
  // instead of too_large, which is the same failure wearing a different label.
  //
  // The cost of a longer timeout is that a genuinely stuck request holds the
  // card that much longer before giving up. That is the better trade: a slow
  // success beats a fast failure on a photo the customer wants to use.
  const CONVERT_TIMEOUT_MS = 90000;

  function fileSizeBucket(bytes) {
    if (bytes < 1048576) return '<1mb';
    if (bytes < 3145728) return '1-3mb';
    if (bytes < 5242880) return '3-5mb';
    if (bytes < 10485760) return '5-10mb';
    // v27: the scale used to stop at ">10mb", which was fine when anything over
    // 5MB was rejected outright. Now that 20MB is accepted, that single bucket
    // would hide the entire newly-allowed range - and the 10-20MB band is
    // exactly where the reported failures live.
    if (bytes < 20971520) return '10-20mb';
    return '>20mb';
  }

  function fileExtOf(name) {
    const m = (name || '').toLowerCase().match(/\.([a-z0-9]+)$/);
    if (!m) return 'other';
    const ext = m[1];
    if (ext === 'heic' || ext === 'heif') return 'heic';
    if (ext === 'jpg' || ext === 'jpeg') return 'jpg';
    if (ext === 'png') return 'png';
    return ext;
  }

  function trackDecode(params) {
    if (window.gtag) {
      gtag('event', 'uploader_image_decode', params);
      dlog('GA4: uploader_image_decode', params);
    }
  }

  function trackDecodeFailure(params) {
    if (window.gtag) {
      gtag('event', 'uploader_image_failed', params);
      dlog('GA4: uploader_image_failed', params);
    }
  }

  // Capability probe. Returns true if the browser can turn these bytes into
  // pixels. No network, no cost.
  async function canBrowserDecode(file) {
    if (typeof createImageBitmap === 'function') {
      try {
        const bmp = await createImageBitmap(file);
        if (bmp && typeof bmp.close === 'function') bmp.close();
        return true;
      } catch (e) {
        // Fall through to the <img> probe below. createImageBitmap failing
        // does not prove the browser can't decode the file (e.g. a Safari
        // build that renders HEIC in <img> but not in createImageBitmap);
        // giving up here would route decodable files to the paid Worker.
      }
    }
    // <img> probe: works on all browsers, and is the authoritative fallback.
    return await new Promise((resolve) => {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => { URL.revokeObjectURL(url); resolve(true); };
      img.onerror = () => { URL.revokeObjectURL(url); resolve(false); };
      img.src = url;
    });
  }

  async function convertViaWorker(file) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), CONVERT_TIMEOUT_MS);
    try {
      const res = await fetch(CONVERT_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/octet-stream',
          // Header values must be ISO-8859-1; a raw unicode filename makes
          // fetch() throw before the request is sent. Encode, and cap length.
          'X-Filename': encodeURIComponent(file.name || 'image').slice(0, 200)
        },
        body: file,
        signal: controller.signal
      });

      if (!res.ok) {
        let code = 'worker_http';
        try {
          const j = await res.json();
          if (j && j.code) code = j.code;
        } catch (e) { /* non-JSON error body */ }
        return { ok: false, stage: code, detail: 'HTTP ' + res.status };
      }

      const blob = await res.blob();
      const convertMs = parseInt(res.headers.get('X-Convert-Ms') || '0', 10);
      const baseName = (file.name || 'image').replace(/\.[^.]+$/, '');
      const converted = new File([blob], baseName + '.jpg', {
        type: 'image/jpeg',
        lastModified: Date.now()
      });

      // The returned JPEG has to decode here, or we have gained nothing.
      if (!(await canBrowserDecode(converted))) {
        return { ok: false, stage: 'post_convert_decode', detail: 'returned jpeg would not decode' };
      }

      dlog('[convert] ' + file.name + ' -> ' + converted.name +
                  ' (' + blob.size + 'B, ' + convertMs + 'ms)');
      return { ok: true, file: converted, convertMs: convertMs };

    } catch (e) {
      const aborted = e && e.name === 'AbortError';
      return {
        ok: false,
        stage: aborted ? 'worker_timeout' : 'worker_http',
        detail: (e && e.name) || 'error'
      };
    } finally {
      clearTimeout(timer);
    }
  }

  // Bounded-concurrency runner. `fn(i)` is called for every index 0..count-1
  // with at most `limit` in flight. Results are written by index by the
  // caller, so completion order never affects output order.
  function laneRunner(count, limit, fn) {
    let cursor = 0;
    async function lane() {
      while (cursor < count) {
        const i = cursor++;
        try {
          await fn(i);
        } catch (e) {
          console.error('[normalize] lane error at index', i, e);
        }
      }
    }
    const lanes = [];
    const laneCount = Math.min(limit, count);
    for (let i = 0; i < laneCount; i++) lanes.push(lane());
    return Promise.all(lanes);
  }

  function telemetryBase(file) {
    return {
      file_ext: fileExtOf(file.name),
      file_size_bucket: fileSizeBucket(file.size),
      product_url: window.location.pathname,
      magnet_shape: MAGNET_SHAPE,
      // v25: the existing decode events have been firing since August but
      // carried no environment, so an in-app-browser failure looked identical
      // to a desktop one. These two make the older events readable too.
      client_env: CLIENT_ENV,
      batch_size: DIAG_BATCH_SIZE
    };
  }

  // Two phases on purpose:
  //   1. Probe every file locally. No network, so it is quick, and it tells us
  //      exactly how many files need converting before any UI appears.
  //   2. Convert only the ones that failed the probe, reporting progress.
  // A selection with nothing to convert never calls onProgress, so the caller
  // never opens the progress toast and the user sees no flash. onProgress
  // reports files STARTED, not finished, so the count never sits at zero.
  async function normalizeFiles(fileList, onProgress) {
    const input = Array.from(fileList);
    const results = new Array(input.length);
    const pending = [];

    // ---- Phase 1: capability probe -----------------------------------------
    await laneRunner(input.length, PROBE_CONCURRENCY, async (i) => {
      const file = input[i];
      if (await canBrowserDecode(file)) {
        trackDecode(Object.assign({ decode_path: 'native' }, telemetryBase(file)));
        results[i] = { ok: true, file: file };
      } else {
        pending.push(i);
      }
    });

    // ---- Phase 2: convert what the browser could not read -------------------
    if (pending.length > 0) {
      const total = pending.length;
      let started = 0;

      await laneRunner(total, CONVERT_CONCURRENCY, async (k) => {
        const i = pending[k];
        const file = input[i];
        const base = telemetryBase(file);

        // Fires before the first await, so the toast appears immediately and
        // never shows a zero.
        started++;
        if (typeof onProgress === 'function') onProgress(Math.min(started, total), total);

        if (file.size > CONVERT_MAX_BYTES) {
          trackDecode(Object.assign({ decode_path: 'failed' }, base));
          trackDecodeFailure(Object.assign(
            { fail_stage: 'too_large', error_detail: String(file.size) }, base));
          results[i] = { ok: false, name: file.name };
        } else {
          const r = await convertViaWorker(file);
          if (r.ok) {
            trackDecode(Object.assign({ decode_path: 'converted', convert_ms: r.convertMs }, base));
            results[i] = { ok: true, file: r.file };
          } else {
            trackDecode(Object.assign({ decode_path: 'failed' }, base));
            trackDecodeFailure(Object.assign(
              { fail_stage: r.stage, error_detail: r.detail }, base));
            results[i] = { ok: false, name: file.name };
          }
        }

      });
    }

    const ok = [];
    const failed = [];
    results.forEach((r, i) => {
      if (r && r.ok) ok.push(r.file);
      else failed.push((r && r.name) || (input[i] && input[i].name) || 'a photo');
    });
    return { files: ok, failed: failed };
  }

  // Cards are inserted into the DOM synchronously but filled asynchronously:
  // each one runs readAsDataURL -> decode -> applyOrientation
  // -> Cropper before its <img> gets a real src. Revealing the cards during
  // that window shows placeholder tiles. This waits for the fill to finish so
  // the popup can appear fully formed.
  const CARD_FILL_TIMEOUT_MS = 45000;

  // visibility (not display) so the footer keeps its layout box and nothing
  // reflows when it comes back.
  function setPrepChromeHidden(hidden) {
    if (hidden) {
      // Already suppressed by an in-flight prep: keep the original tracking
      // list so the restore still knows what to put back.
      if (prepHiddenEls.length > 0) return;
      [document.querySelector('.sticky-footer'), saveAllBtn, uploadStatusMessage]
        .forEach((el) => {
          if (el && el.style.visibility !== 'hidden') {
            prepHiddenEls.push(el);
            el.style.visibility = 'hidden';
          }
        });
    } else {
      prepHiddenEls.forEach((el) => { el.style.visibility = ''; });
      prepHiddenEls = [];
      const badge = document.querySelector('.images-below-badge');
      if (badge) badge.style.display = 'none';
    }
  }

  function waitForCardsReady(expected) {
    return new Promise((resolve) => {
      const startedAt = Date.now();
      const word = expected === 1 ? 'photo' : 'photos';

      const tick = () => {
        const ready = imageObjects.length;
        if (ready >= expected) { resolve(); return; }
        // A card whose image fails to load never pushes, so bail out rather
        // than hang on the toast forever.
        if (Date.now() - startedAt > CARD_FILL_TIMEOUT_MS) {
          console.warn('[prep] card fill timed out at ' + ready + '/' + expected);
          diagCardFailed('cards_ready_timeout', {
            photo_index: ready,
            error_detail: ready + ' of ' + expected
          });
          resolve();
          return;
        }
        showUploadProgressToast(
          `Preparing ${Math.min(ready + 1, expected)} of ${expected} ${word}...please wait.`
        );
        setTimeout(tick, 120);
      };

      tick();
    });
  }

  uploadBtn.addEventListener('click', () => {
    let gridImagesCount = getGridImageCount();
    fileInput.value = '';

    if (gridImagesCount === MAX_IMAGES) {
      clearAllImages();
      setTimeout(() => {
        fileInput.click();
      }, 50);
    } else {
      setTimeout(() => {
        fileInput.click();
      }, 10);
    }
  });

  fileInput.addEventListener('change', async (event) => {
    // Snapshot synchronously: the FileList is read before any await.
    const selectedFiles = Array.from(event.target.files);
    if (selectedFiles.length === 0) {
      return;
    }

    // Open the popup immediately with the cards area hidden. The toast is
    // appended to .popup-content, so that element has to be rendered for the
    // toast to be visible; visibility:hidden keeps layout intact so scroll
    // heights are correct the moment we reveal.
    imageCardsContainer.innerHTML = '';
    imageCardsContainer.style.visibility = 'hidden';
    popup.style.display = 'flex';
    document.body.classList.add('popup-open');
    document.body.style.overflow = 'hidden';
    prepInProgress = true;
    setPrepChromeHidden(true);
    showUploadProgressToast('Preparing your photos...please wait.');

    // v28.2: the marker now opens HERE rather than at the card loop.
    //
    // uploader_image_decode fires during the probe/convert phase below and
    // uploader_card_ready fires at the end of card building, so the gap we have
    // been measuring spans all three prep phases. Starting the marker at the
    // card loop left phases 1 and 2 - size check, decode probe, and the network
    // round trip to the conversion worker - inside the gap but outside the
    // detector. A page dying during conversion was invisible by construction.
    //
    // Phase 3 rewrites this with the real per-card count once slot maths has
    // run; until then the selected count is the best estimate available.
    writeBuildMarker(selectedFiles.length);
    markBuildPhase('probe');

    // Unwinds the prep state on any early return.
    function abortPrep() {
      clearBuildMarker();
      prepInProgress = false;
      setPrepChromeHidden(false);
      hideUploadProgressToast();
      imageCardsContainer.style.visibility = '';
      popup.style.display = 'none';
      document.body.classList.remove('popup-open');
      document.body.style.overflow = '';
    }

    // Probe/convert gate. Runs before the slot math and before any card is
    // rendered, so the one-card-equals-one-image invariant is preserved.
    // "Converting" counts only the files that failed the decode probe, which is
    // a different total from the card-fill phase below - hence the distinct verb.
    const normalized = await normalizeFiles(selectedFiles, (started, total) => {
      const word = total === 1 ? 'photo' : 'photos';
      markBuildPhase('convert');
      showUploadProgressToast(`Converting ${started} of ${total} ${word}...please wait.`);
    });

    const files = normalized.files;

    if (normalized.failed.length > 0) {
      const n = normalized.failed.length;
      showMessage(
        mainMessageBox,
        n + (n === 1 ? " photo couldn't be processed and was skipped: " :
                       " photos couldn't be processed and were skipped: ") +
          normalized.failed.join(', '),
        true,
        true
      );
    }

    // Every file failed: close the prep popup rather than leave an empty one up.
    if (files.length === 0) {
      abortPrep();
      return;
    }

    let gridImagesCount = getGridImageCount();
    let availableSlots = MAX_IMAGES - gridImagesCount;
    let filesToProcess = Math.min(files.length, availableSlots);

    if (files.length > availableSlots) {
      showMessage(mainMessageBox, `You can only upload ${availableSlots} more ${availableSlots === 1 ? 'image' : 'images'}. Only the first ${filesToProcess} will be processed.`, true);
    }

    if (filesToProcess === 0) {
      abortPrep();
      showMessage(mainMessageBox, `Grid is full. Please remove some images or click "Replace All Images" to start over.`, true);
      return;
    }
    
    const totalImages = gridImagesCount + filesToProcess;
    let statusMessage = '';

    if (MAX_IMAGES === 1) {
      statusMessage = '1 image ready to upload.';
    } else if (files.length > availableSlots) {
      if (window.innerWidth <= 767) {
        statusMessage = `Only the first ${MAX_IMAGES} images will be used.`;
      } else {
        statusMessage = `More than ${MAX_IMAGES} images have been selected, only the first ${MAX_IMAGES} images will be uploaded.`;
      }
    } else if (totalImages === MAX_IMAGES) {
      statusMessage = `All ${MAX_IMAGES} images are ready to upload.`;
    } else {
      statusMessage = `${totalImages} of ${MAX_IMAGES} ${totalImages === 1 ? 'image' : 'images'} ready to upload.`;
    }
    
    // Store the initial status message to display in the scrollable area
    const initialScrollableMessage = statusMessage;

    imageCardsContainer.innerHTML = '';
    clearAllCardWatchdogs();
    releaseAllSourceURLs();
    imageObjects = [];
    
    // Create the instruction slideshow at the TOP of the scrollable area
    // (returns null when no step images exist for this magnet shape)
    const instructionSlideshow = buildInstructionSlideshow();
    if (instructionSlideshow) {
      imageCardsContainer.appendChild(instructionSlideshow);
    }

    // Instruction paragraph, rendered below the slideshow. Shown when the shape
    // has no slideshow at all, or when SHOW_INSTRUCTION_TEXT opts that shape in.
    cardsInstructionText = null;
    if (!instructionSlideshow || SHOW_INSTRUCTION_TEXT[instructionShapeKey()]) {
      cardsInstructionText = document.createElement('div');
      cardsInstructionText.id = 'cards-instruction-text';
      cardsInstructionText.innerHTML = IS_RECT
        ? 'These are 2"x3" rectangle magnets. For each photo, choose Portrait or Landscape, then resize and move the cropper to frame your shot. You can set the orientation independently on every image.'
        : 'Close-ups and portraits look the best on a 2"x2" square magnet face. Use the Square cropper for best results.<br><br>If you prefer to not crop your image, then choose Entire Image, be aware that black or white color bars will show on non-square images.';
      imageCardsContainer.appendChild(cardsInstructionText);
    }
    
    // Create "Start Cropping!" button (mobile only, hidden via CSS on larger screens)
    const startCroppingBtn = document.createElement('button');
    startCroppingBtn.id = 'start-cropping-btn';
    startCroppingBtn.type = 'button';
    startCroppingBtn.innerHTML = `
      Start Cropping!
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:20px;height:20px;margin-left:8px;vertical-align:middle;">
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    `;
    startCroppingBtn.addEventListener('click', () => {
      const firstImageCard = imageCardsContainer.querySelector('.image-card');
      if (firstImageCard) {
        firstImageCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
    imageCardsContainer.appendChild(startCroppingBtn);
    
    popup.style.display = 'flex';
    document.body.classList.add('popup-open');
    document.body.style.overflow = 'hidden';

    // Initially disable the save button until all crop modes are selected
    if (saveAllBtn) {
      saveAllBtn.disabled = true;
    }

    DIAG_BATCH_SIZE = filesToProcess;
    // v28.2: re-stamped with the real count now that slot maths has run.
    writeBuildMarker(filesToProcess);
    markBuildPhase('cards');

    Array.from(files).slice(0, filesToProcess).forEach((file, index) => {
      const uniqueId = createUniqueId();
      // v28: if this card never reaches a terminal state, say so.
      startCardWatchdog(uniqueId, {
        photo_index: index + 1,
        file_ext: fileExtOf(file.name),
        file_size_bucket: fileSizeBucket(file.size)
      });
      // Single-image products (matching sets, mosaics) show '1 of 1' centered,
      // matching the multi-image card layout.
      const photoLabel = MAX_IMAGES === 1 ? '1 of 1' : `${gridImagesCount + index + 1} of ${MAX_IMAGES}`;
      
      const cardHtml = `
        <div class="image-card" data-id="${uniqueId}" data-card-index="${index}" data-quantity="1">
          <div class="card-header">
            <div class="quantity-stepper" id="qty-stepper-${uniqueId}">
              <button type="button" class="qty-btn qty-minus" data-action="decrease">&minus;</button>
              <span class="qty-value">1</span>
              <button type="button" class="qty-btn qty-plus" data-action="increase">+</button>
            </div>
            <h4>${photoLabel}</h4>
            <div class="card-trash-icon" id="trash-icon-${uniqueId}" title="Remove this image.">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </div>
          </div>
          <div class="controls-row">
            <div class="crop-mode-control">
              <div class="crop-mode-label-row">
                <div class="card-status-icon warning" id="status-icon-${uniqueId}">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                  </svg>
                </div>
                <label for="crop-mode-${uniqueId}">${(IS_RECT || MOSAIC_HAS_ORIENTATIONS) ? 'Select Orientation:' : 'Select Cropping Style:'}</label>
              </div>
              <select class="crop-mode-select" id="crop-mode-${uniqueId}">
                ${(IS_RECT || MOSAIC_HAS_ORIENTATIONS)
                  ? `<option value="select-one" selected>Activate Cropper</option>
                <option value="portrait">Portrait: Resize and Move Cropper</option>
                <option value="landscape">Landscape: Resize and Move Cropper</option>`
                  : `<option value="select-one" selected>Activate Cropper</option>
                <option value="manual-crop">Square: Resize and Move (Best)</option>`}
              </select>
            </div>
          </div>
          <div class="image-container" style="background-color: #ccc; background-image: linear-gradient(45deg, #999 25%, transparent 25%), linear-gradient(-45deg, #999 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #999 75%), linear-gradient(-45deg, transparent 75%, #999 75%); background-size: 20px 20px; background-position: 0 0, 0 10px, 10px -10px, -10px 0px;">
            <img class="uploaded-image" src="#" alt="Uploaded Image" id="uploaded-image-${uniqueId}">
          </div>
          ${MOSAIC_CONFIG ? `
          <button type="button" class="mosaic-preview-hint" id="mosaic-preview-hint-${uniqueId}">
            See Your Magnet Preview
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="hint-arrow">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>` : ''}
          <div class="low-res-warning" id="low-res-warning-${uniqueId}" style="display: none;">
            ⚠️ Low Resolution - may print blurry.
          </div>
          <div class="blur-warning" id="blur-warning-${uniqueId}" style="display: none;">
            ⚠️ Blurry image - may not print clearly.
          </div>
          ${MOSAIC_CONFIG ? `
          <div class="mosaic-preview" id="mosaic-preview-${uniqueId}" style="display: none;">
            <div class="mosaic-preview-title">Magnet Preview</div>
            <canvas class="mosaic-preview-canvas"></canvas>
          </div>` : ''}
          <div class="card-navigation-buttons">
            <button class="nav-btn nav-btn-prev" type="button" data-card-id="${uniqueId}">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>
            <button class="nav-btn nav-btn-next" type="button" data-card-id="${uniqueId}">
              Next Image
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
          </div>
        </div>
      `;
  
      imageCardsContainer.insertAdjacentHTML('beforeend', cardHtml);
      const newCard = imageCardsContainer.querySelector(`[data-id="${uniqueId}"]`);
      const uploadedImage = newCard.querySelector('.uploaded-image');
      const imageContainer = newCard.querySelector('.image-container');
      const cropModeSelect = newCard.querySelector('.crop-mode-select');

      // Add the initial highlight class to the dropdown and card
      cropModeSelect.classList.add('needs-selection');
      newCard.classList.add('needs-selection');

      // ========== TRASH ICON CLICK HANDLER ==========
      const trashIcon = newCard.querySelector('.card-trash-icon');
      trashIcon.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Track trash icon usage with Google Analytics
        if (window.gtag) {
          gtag('event', 'Uploader_image_card_deleted', {
            'product_url': window.location.pathname
          });
          dlog('GA4 Event tracked: image card deleted');
        }
        
        // Flash red briefly
        trashIcon.classList.add('flash-red');
        
        setTimeout(() => {
          // If this is the only card, close the popup entirely
          if (imageObjects.length <= 1) {
            // Trigger same behavior as close button
            popup.style.display = 'none';
            document.body.classList.remove('popup-open');
            document.body.style.overflow = '';
            
            if (uploaderContainer) {
              setTimeout(() => {
                uploaderContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }, 100);
            }
            
            imageObjects.forEach(obj => {
              if (obj.cropper) {
                obj.cropper.destroy();
              }
            });
            clearAllCardWatchdogs();
            releaseAllSourceURLs();
            imageObjects = [];
            imageCardsContainer.innerHTML = '';
            
            // Remove the images below badge
            const badge = document.querySelector('.images-below-badge');
            if (badge) badge.remove();
            
            fileInput.value = '';
            return;
          }
          
          // Find and remove the imageObject for this card
          const objIndex = imageObjects.findIndex(o => o.card === newCard);
          if (objIndex !== -1) {
            // Destroy cropper if exists
            if (imageObjects[objIndex].cropper) {
              imageObjects[objIndex].cropper.destroy();
            }
            releaseSourceURL(imageObjects[objIndex]);
            // Remove from array
            imageObjects.splice(objIndex, 1);
          }
          
          // v28: a card deleted mid-build is a deliberate removal, not a
          // stalled one - stand its watchdog down so it cannot report a
          // timeout for a card the customer chose to discard.
          clearCardWatchdog(uniqueId);

          // Remove the card from DOM
          newCard.remove();
          
          // Show toast notification
          showToast('Image removed');
          
          // Update all card titles to reflect new positions
          updateAllCardTitles();
          
          // Update quantity button states
          updateAllQuantityButtons();
          
          // Update navigation buttons
          setupCardNavigation();
          
          // Update crop selection status message
          updateCropSelectionStatus();
          
          // Update save button state
          updateSaveAllButtonState();
          
          // Scroll to first card that needs a crop style selection
          scrollToFirstCardNeedingSelection();
          
        }, 150); // 150ms flash duration
      });

      // ========== QUANTITY STEPPER CLICK HANDLERS ==========
      const quantityStepper = newCard.querySelector('.quantity-stepper');
      const minusBtn = newCard.querySelector('.qty-minus');
      const plusBtn = newCard.querySelector('.qty-plus');
      const qtyValue = newCard.querySelector('.qty-value');
      
      minusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        let currentQty = parseInt(newCard.dataset.quantity) || 1;
        if (currentQty > 1) {
          currentQty--;
          newCard.dataset.quantity = currentQty;
          qtyValue.textContent = currentQty;
          
          // Update all titles and button states
          updateAllCardTitles();
          updateAllQuantityButtons();
        }
      });
      
      plusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const remainingSlots = getRemainingSlots();
        if (remainingSlots > 0) {
          let currentQty = parseInt(newCard.dataset.quantity) || 1;
          currentQty++;
          newCard.dataset.quantity = currentQty;
          qtyValue.textContent = currentQty;
          
          // Update all titles and button states
          updateAllCardTitles();
          updateAllQuantityButtons();
        }
      });
      
      // Hide quantity stepper for single-image products, but keep its SPACE
      // (visibility:hidden) so the header stays balanced - '1 of 1' centered,
      // trash icon on the right, like multi-image cards.
      if (MAX_IMAGES === 1) {
        quantityStepper.style.visibility = 'hidden';
      }

      let cropper = null;
      let savedCropBoxData = null;
      let currentRotation = 0;

      // ========== ADD ROTATE BUTTON ==========
      const rotateBtn = document.createElement('button');
      rotateBtn.className = 'rotate-btn';
      rotateBtn.type = 'button';
      rotateBtn.title = 'Rotate image clockwise.';
      rotateBtn.innerHTML = `
        <svg class="rotate-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"/>
        </svg>
      `;
      imageContainer.appendChild(rotateBtn);

      // Prevent touch events from bubbling to cropper
      rotateBtn.addEventListener('touchstart', (e) => {
        e.stopPropagation();
      }, { passive: true });

      rotateBtn.addEventListener('touchmove', (e) => {
        e.stopPropagation();
      }, { passive: true });

      rotateBtn.addEventListener('touchend', (e) => {
        e.stopPropagation();
      }, { passive: true });

      // ========== ROTATE BUTTON CLICK HANDLER (FIXED) ==========
      rotateBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Don't proceed if button is disabled
        if (rotateBtn.disabled) {
          return;
        }
        
        // Track rotate button usage with Google Analytics
        if (window.gtag) {
          gtag('event', 'rotate_button_clicked', {
            'product_url': window.location.pathname,
            'max_images': MAX_IMAGES
          });
          dlog('GA4 Event tracked: rotate button clicked');
        }
        
        if (cropper) {
          // Get current crop and canvas data before rotation
          const cropBoxData = cropper.getCropBoxData();
          
          currentRotation = (currentRotation + 90) % 360;
          cropper.rotate(90);
          
          // Wait briefly for rotation to complete
          setTimeout(() => {
            const containerData = cropper.getContainerData();
            const newCanvasData = cropper.getCanvasData();
            
            // 1. Re-center the Canvas (Image) within the container
            // This ensures the rotation looks like it happened around the card's center
            cropper.setCanvasData({
              left: (containerData.width - newCanvasData.width) / 2,
              top: (containerData.height - newCanvasData.height) / 2,
            });

            // 2. Re-center the Crop Box to keep it centered in the frame
            const newCropBoxData = cropper.getCropBoxData();
            // This is the key fix to prevent the crop box from rotating off-center
            cropper.setCropBoxData({
              left: (containerData.width - newCropBoxData.width) / 2,
              top: (containerData.height - newCropBoxData.height) / 2,
            });

          }, 50);
        }
      });

      // v26: the original file is referenced by URL rather than read into a
      // base64 string. readAsDataURL turned a 15MB photo into a ~20MB string
      // that the handlers below closed over for the life of the card; nine of
      // those was ~180MB of retained text doing no work. The object URL is a
      // short string and the file stays disk-backed.
      //
      // The handler shape is unchanged - e.target.result now carries the object
      // URL instead of a data URL, and an <img> src accepts either - so every
      // path below, including the fallbacks, behaves exactly as it did in v25.
      const sourceURL = URL.createObjectURL(file);
      const reader = { onload: null, onerror: null };
      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          // v28: captured up front. releaseDecodedImage() below resets the
          // element to a 1x1 pixel to free the bitmap, after which
          // naturalWidth/naturalHeight both read 1 - so nothing downstream may
          // read them from the element again.
          const srcW = img.naturalWidth;
          const srcH = img.naturalHeight;

          // Check for low resolution image (either dimension below 400px)
          const lowResWarning = newCard.querySelector('.low-res-warning');
          const initTH = getLowResThreshold('');
          if (srcW < initTH.width || srcH < initTH.height) {
            if (lowResWarning) {
              lowResWarning.style.display = 'block';
            }
            dlog(`Low resolution image detected: ${srcW}x${srcH}`);
          } else {
            if (lowResWarning) {
              lowResWarning.style.display = 'none';
            }
          }
          
          getImageOrientation(file, async (orientation) => {
            // v25: identifies this photo in GA4 without identifying the customer.
            const diagCtx = {
              photo_index: index + 1,
              file_ext: fileExtOf(file.name),
              file_size_bucket: fileSizeBucket(file.size),
              image_px: diagMpBucket(srcW, srcH)
            };
            try {
              const correctedDataURL = await applyOrientation(img, orientation > 0 ? orientation : 1, diagCtx);

              // v28: the orientation step has copied what it needs onto the
              // working canvas. Drop the full-resolution bitmap now rather than
              // holding it for the life of the card - the single largest saving
              // available in this pipeline.
              releaseDecodedImage(img);

              // v20: border trim removed - the customer's image loads exactly
              // as uploaded (after EXIF orientation correction only).
              const finalDataURL = correctedDataURL;
              
              // v25: the card's <img> had no error handling whatsoever. A src
              // that never rendered produced a blank card and zero signal -
              // the most likely home of the reported bug.
              uploadedImage.onerror = function () {
                diagCardFailed('card_img_error', diagCtx);
              };
              uploadedImage.addEventListener('load', function onDiagCardLoad() {
                uploadedImage.removeEventListener('load', onDiagCardLoad);
                if (!uploadedImage.naturalWidth || !uploadedImage.naturalHeight) {
                  diagCardFailed('card_img_zero_size', diagCtx);
                }
              });

              uploadedImage.src = finalDataURL;
              imageContainer.style.position = 'relative';
              imageContainer.style.overflow = 'hidden';
              // Start with checkered pattern since default is "Select One"
              imageContainer.style.backgroundColor = '#ccc';
              imageContainer.style.backgroundImage = `
                linear-gradient(45deg, #999 25%, transparent 25%),
                linear-gradient(-45deg, #999 25%, transparent 25%),
                linear-gradient(45deg, transparent 75%, #999 75%),
                linear-gradient(-45deg, transparent 75%, #999 75%)
              `;
              imageContainer.style.backgroundSize = '20px 20px';
              imageContainer.style.backgroundPosition = '0 0, 0 10px, 10px -10px, -10px 0px'; 

              // Calculate minimum crop box size based on container (25% of container, minimum 50px)
              const containerWidth = imageContainer.offsetWidth;
              const minCropSize = Math.max(50, Math.floor(containerWidth * 0.25));

              try {
                cropper = new Cropper(uploadedImage, {
                  aspectRatio: (IS_RECT || MOSAIC_HAS_ORIENTATIONS) ? NaN : 1,
                  viewMode: 1,
                  dragMode: 'crop',
                  // --- START: Zoom/Move Disabling Fix (from previous turn) ---
                  movable: false, // Prevents dragging the image
                  zoomable: false, // CRITICAL: Disables pinch-zoom and scroll zoom
                  restore: false, // Prevents canvas size reset on certain events
                  // --- END: Zoom/Move Disabling Fix ---
                  rotatable: true,
                  responsive: true,
                  checkCrossOrigin: false,
                  background: false,
                  modal: true,
                  guides: true,
                  center: true,
                  highlight: true,
                  cropBoxResizable: true,
                  cropBoxMovable: true,
                  toggleDragModeOnDblclick: false,
                  autoCropArea: 1.0,
                  minCropBoxWidth: minCropSize,
                  minCropBoxHeight: minCropSize,
                  ready: function () {
                    dlog('Cropper initialized');
                    // Default mode is "Select One" - hide the cropper
                    cropper.clear();
                    cropper.setDragMode('none');
                    updateBorderColor(newCard);
                  },
                  crop: function () {
                    updateBackground(newCard);
                    const mode = cropModeSelect.value;
                    if (isCropperMode(mode)) {
                      savedCropBoxData = cropper.getCropBoxData();
                      // Check low-res warning based on cropped dimensions
                      const obj = imageObjects.find(o => o.card === newCard);
                      const origWidth = obj ? obj.originalWidth : srcW;
                      const origHeight = obj ? obj.originalHeight : srcH;
                      updateLowResWarning(newCard, cropper, origWidth, origHeight, mode);
                      if (MOSAIC_CONFIG) scheduleMosaicPreview(newCard);
                    }
                  }
                });

                imageObjects.push({
                  file: file,
                  dataURL: finalDataURL,
                  cropper: cropper,
                  card: newCard,
                  savedCropBoxData: null,
                  originalWidth: srcW,
                  originalHeight: srcH,
                  srcObjectURL: sourceURL
                });

                // v28: reached a terminal state - stand the watchdog down.
                clearCardWatchdog(uniqueId);

                // v25: success denominator. Without this the failure counts
                // have nothing to be a percentage of.
                diagSend('uploader_card_ready', diagCtx);

                // Run blur detection AFTER imageObjects.push to ensure obj can be found
                detectBlur(uploadedImage).then(result => {
                  dlog(`[BlurDetect] Card ${newCard.dataset.id}: isBlurry=${result.isBlurry}, variance=${result.variance.toFixed(2)}`);
                  const obj = imageObjects.find(o => o.card === newCard);
                  if (obj) {
                    obj.isBlurry = result.isBlurry;
                    obj.blurVariance = result.variance;
                    updateBlurWarning(newCard, result.isBlurry);
                  } else {
                    console.warn('[BlurDetect] Could not find imageObject for card');
                  }
                });

                updateBackground(newCard);
              } catch (error) {
                console.error('Cropper initialization error:', error);
                diagCardFailed('cropper_init', Object.assign(
                  { error_detail: String((error && (error.name || error.message)) || 'error').slice(0, 90) },
                  diagCtx));
                updateBothStatusMessages('Cropper failed. Using original image.', true, true);
                uploadedImage.src = e.target.result;
                imageObjects.push({
                  file: file,
                  dataURL: e.target.result,
                  cropper: null,
                  card: newCard,
                  savedCropBoxData: null,
                  originalWidth: srcW,
                  originalHeight: srcH,
                  srcObjectURL: sourceURL
                });
                clearCardWatchdog(uniqueId);
                
                // Run blur detection for fallback path
                detectBlur(uploadedImage).then(result => {
                  const obj = imageObjects.find(o => o.card === newCard);
                  if (obj) {
                    obj.isBlurry = result.isBlurry;
                    obj.blurVariance = result.variance;
                    updateBlurWarning(newCard, result.isBlurry);
                  }
                });
                
                updateBackground(newCard);
                updateBorderColor(newCard);
              }
            } catch (error) {
              // v28: released here too - the fallback displays the original via
              // its object URL and has no use for this decode either.
              releaseDecodedImage(img);
              console.error('Orientation correction error:', error);
              diagCardFailed('orientation_exception', Object.assign(
                { error_detail: String((error && (error.name || error.message)) || 'error').slice(0, 90) },
                diagCtx));
              updateBothStatusMessages('Orientation correction failed. Using original image.', true, true);
              uploadedImage.src = e.target.result;
              imageObjects.push({
                file: file,
                dataURL: e.target.result,
                cropper: null,
                card: newCard,
                savedCropBoxData: null,
                originalWidth: srcW,
                originalHeight: srcH,
                srcObjectURL: sourceURL
              });
              clearCardWatchdog(uniqueId);
              
              // Run blur detection for fallback path
              detectBlur(uploadedImage).then(result => {
                const obj = imageObjects.find(o => o.card === newCard);
                if (obj) {
                  obj.isBlurry = result.isBlurry;
                  obj.blurVariance = result.variance;
                  updateBlurWarning(newCard, result.isBlurry);
                }
              });
              
              updateBackground(newCard);
              updateBorderColor(newCard);
            }
          });
        };
        img.onerror = () => {
          clearCardWatchdog(uniqueId);
          diagCardFailed('img_decode', {
            photo_index: index + 1,
            file_ext: fileExtOf(file.name),
            file_size_bucket: fileSizeBucket(file.size)
          });
          updateBothStatusMessages('Failed to load image.', true, true);
        };
      };
      reader.onerror = () => {
        clearCardWatchdog(uniqueId);
        diagCardFailed('file_read', {
          photo_index: index + 1,
          file_ext: fileExtOf(file.name),
          file_size_bucket: fileSizeBucket(file.size)
        });
        updateBothStatusMessages('Error reading image file.', true, true);
      };

      // v26: replaces reader.readAsDataURL(file). Deferred by a tick so cards
      // still start asynchronously - going synchronous here would kick all
      // twelve decodes off in the same frame, which is the opposite of what
      // this change is for.
      setTimeout(() => {
        if (!sourceURL) {
          reader.onerror();
          return;
        }
        reader.onload({ target: { result: sourceURL } });
      }, 0);

      cropModeSelect.addEventListener('change', () => {
        const obj = imageObjects.find(o => o.card === newCard);
        const mode = cropModeSelect.value;
        
        // Toggle the highlight class based on selection (both dropdown and card)
        if (mode === 'select-one') {
          cropModeSelect.classList.add('needs-selection');
          cropModeSelect.classList.remove('selection-complete');
          newCard.classList.add('needs-selection');
          newCard.classList.remove('selection-complete');
        } else {
          cropModeSelect.classList.remove('needs-selection');
          cropModeSelect.classList.add('selection-complete');
          newCard.classList.remove('needs-selection');
          newCard.classList.add('selection-complete');
        }
        
        if (cropper) {
          // Only save crop box data if cropper is currently active (has a valid crop box)
          // This prevents overwriting good saved data when switching between entire-image modes
          const currentCropBoxData = cropper.getCropBoxData();
          const hasCropBox = currentCropBoxData && currentCropBoxData.width > 0 && currentCropBoxData.height > 0;
          
          if (hasCropBox) {
            obj.savedCropBoxData = currentCropBoxData;
          }
          
          // Handle mode changes
          if (mode === 'select-one') {
            // Select One: Hide cropper, black background
            cropper.clear();
            cropper.setDragMode('none');
            updateBackground(newCard);
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                updateBorderColor(newCard);
              });
            });
          } else if (mode === 'entire-black' || mode === 'entire-white') {
            // Entire Image modes: Hide cropper, set background
            cropper.clear();
            cropper.setDragMode('none');
            updateBackground(newCard);
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                updateBorderColor(newCard);
              });
            });
          } else if (mode === 'portrait' || mode === 'landscape') {
            // Rectangle orientation: lock cropper to 2:3 (portrait) or 3:2 (landscape),
            // show it, and place a ~90% inset centered box so handles are always reachable.
            const targetAspect = IS_MOSAIC ? MOSAIC_ASPECT[mode] : RECT_ASPECT[mode];
            cropper.setAspectRatio(targetAspect);
            cropper.crop();
            cropper.setDragMode('crop');
            updateBackground(newCard);
            // Only restore a saved box if the orientation is unchanged. Restoring a
            // portrait box under a landscape lock (or vice versa) makes Cropper shrink
            // the box to reconcile the mismatched aspect, so on an actual orientation
            // switch we recompute a fresh ~90% inset box instead.
            const sameOrientation = obj.savedCropBoxData && obj.lastRectOrientation === mode;
            if (sameOrientation) {
              cropper.setCropBoxData(obj.savedCropBoxData);
            } else {
              // Largest targetAspect box at ~90% of the container, centered, handles inset.
              setTimeout(() => {
                const containerData = cropper.getContainerData();
                const maxW = containerData.width * 0.9;
                const maxH = containerData.height * 0.9;
                // Fit the target aspect within the 90% bounds (letterbox math), which
                // fills the dominant axis for each orientation.
                let cropWidth = maxW;
                let cropHeight = cropWidth / targetAspect;
                if (cropHeight > maxH) {
                  cropHeight = maxH;
                  cropWidth = cropHeight * targetAspect;
                }
                const cropLeft = (containerData.width - cropWidth) / 2;
                const cropTop = (containerData.height - cropHeight) / 2;
                cropper.setCropBoxData({
                  left: cropLeft,
                  top: cropTop,
                  width: cropWidth,
                  height: cropHeight
                });
                // Remember this as the saved box for this orientation.
                obj.savedCropBoxData = cropper.getCropBoxData();
              }, 50);
            }
            obj.lastRectOrientation = mode;
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                updateBorderColor(newCard);
              });
            });
          } else if (mode === 'manual-crop') {
            // Manual Crop: Show cropper, black background
            cropper.crop();
            cropper.setDragMode('crop');
            updateBackground(newCard);
            if (obj.savedCropBoxData) {
              // Restore previously saved crop box
              cropper.setCropBoxData(obj.savedCropBoxData);
            } else {
              // First time selecting Manual Crop - use default centered crop for square images
              setTimeout(() => {
                const canvasData = cropper.getCanvasData();
                const containerData = cropper.getContainerData();
                const imageWidth = canvasData.naturalWidth;
                const imageHeight = canvasData.naturalHeight;
                
                // Check if image is square or nearly square
                const aspectRatio = imageWidth / imageHeight;
                const isSquare = aspectRatio >= 0.85 && aspectRatio <= 1.15;
                
                if (isSquare) {
                  // Set crop box to 90% of container size and center it
                  const cropSize = Math.min(containerData.width, containerData.height) * 0.9;
                  const cropLeft = (containerData.width - cropSize) / 2;
                  const cropTop = (containerData.height - cropSize) / 2;
                  
                  cropper.setCropBoxData({
                    left: cropLeft,
                    top: cropTop,
                    width: cropSize,
                    height: cropSize
                  });
                }
                // For non-square images, cropper's default behavior handles it
              }, 50);
            }
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                updateBorderColor(newCard);
              });
            });
          }
        } else {
          updateBorderColor(newCard);
          updateBackground(newCard);
        }
        
        // Update save button state based on all crop mode selections
        updateSaveAllButtonState();
        
        // Update the crop selection status message in the footer
        updateCropSelectionStatus();
        
        // Update the Next button state for this card
        updateNextButtonState(newCard);
        
        // Update low-res warning based on current mode and crop dimensions
        if (obj) {
          // Use a small delay for cropper modes (manual-crop, portrait, landscape) to let cropper update
          if (isCropperMode(mode)) {
            setTimeout(() => {
              updateLowResWarning(newCard, cropper, obj.originalWidth, obj.originalHeight, mode);
            }, 100);
          } else {
            updateLowResWarning(newCard, cropper, obj.originalWidth, obj.originalHeight, mode);
          }
        }
        
        // Mosaic seam preview follows the mode: renders for cropper modes (the
        // crop event will refine it once the box settles), hides otherwise.
        if (MOSAIC_CONFIG) scheduleMosaicPreview(newCard);
        
        // Update status icon based on selection
        const statusIcon = newCard.querySelector('.card-status-icon');
        if (statusIcon) {
          if (mode === 'select-one') {
            // Show warning icon for no selection
            statusIcon.classList.remove('complete');
            statusIcon.classList.add('warning');
            statusIcon.innerHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
            `;
          } else {
            // Show green checkmark for valid selection
            statusIcon.classList.remove('warning');
            statusIcon.classList.add('complete');
            statusIcon.innerHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="9 12 12 15 16 10"></polyline>
              </svg>
            `;
          }
        }
      });
    });
    
    // Create and append the cards status message at the BOTTOM of the scrollable area
    // This shows the initial "X of Y images ready to upload" message and stays static
    cardsStatusMessage = document.createElement('div');
    cardsStatusMessage.id = 'cards-status-message';
    cardsStatusMessage.className = 'message-box info';
    cardsStatusMessage.style.display = 'block';
    cardsStatusMessage.textContent = initialScrollableMessage;
    imageCardsContainer.appendChild(cardsStatusMessage);
    
    // Setup navigation buttons for mobile
    setupCardNavigation();
    
    // Setup initial quantity button states
    updateAllQuantityButtons();
    
    // Update the sticky footer with the initial crop selection status message
    updateCropSelectionStatus();
    
    // Setup the "images below" badge scroll listener
    setupImagesBelowBadgeListener();
    
    // Hold the toast until every card has an image in it, then reveal the whole
    // popup at once instead of letting placeholder tiles show through.
    await waitForCardsReady(filesToProcess);
    // v28.2: prep is over either way - a card still outstanding is the
    // watchdog's problem, not the crash marker's.
    clearBuildMarker();
    prepInProgress = false;
    imageCardsContainer.style.visibility = '';
    setPrepChromeHidden(false);
    hideUploadProgressToast();
    // Badge updates were suppressed during prep; recompute now that the cards
    // are visible and scroll positions are real.
    setTimeout(updateImagesBelowBadge, 100);

    // Scroll behavior when popup opens
    setTimeout(() => {
      if (imageCardsContainer) {
        // On mobile with images already in grid, scroll to first image card
        if (window.innerWidth <= 767 && gridImagesCount > 0) {
          const firstImageCard = imageCardsContainer.querySelector('.image-card');
          if (firstImageCard) {
            firstImageCard.scrollIntoView({ behavior: 'auto', block: 'start' });
          }
        } else {
          // Otherwise scroll to top (show instructions)
          imageCardsContainer.scrollTop = 0;
        }
      }
    }, 50);
  });


  saveAllBtn.addEventListener('click', async () => {
      // Track upload event with Google Analytics including crop style selections
  if (window.gtag) {
    // Count crop mode selections
    const cropModeCounts = {
      'entire-black': 0,
      'entire-white': 0,
      'manual-crop': 0,
      'portrait': 0,
      'landscape': 0
    };
    
    imageObjects.forEach(obj => {
      const cropModeSelect = obj.card.querySelector('.crop-mode-select');
      const mode = cropModeSelect ? cropModeSelect.value : 'manual-crop';
      if (cropModeCounts.hasOwnProperty(mode)) {
        cropModeCounts[mode]++;
      }
    });
    
    gtag('event', 'Uploader_Upload_Cropped_Images', {
      'image_count': imageObjects.length,
      'product_url': window.location.pathname,
      'entire_black_count': cropModeCounts['entire-black'],
      'entire_white_count': cropModeCounts['entire-white'],
      'manual_crop_count': cropModeCounts['manual-crop'],
      'portrait_count': cropModeCounts['portrait'],
      'landscape_count': cropModeCounts['landscape']
    });
    dlog('GA4 Event tracked: Uploader_Upload_Cropped_Images with', imageObjects.length, 'images');
    dlog('Crop modes:', cropModeCounts);
  }
    saveAllBtn.disabled = true;
    const uploadedUrls = [];
    let uploadFailed = false;

    // Show status message on mobile during upload
    if (uploadStatusMessage) {
      uploadStatusMessage.classList.add('uploading');
    }

    updateStickyFooterOnly('Starting uploads...', false, true);

    imageObjects.forEach(obj => {
      const cropModeSelect = obj.card.querySelector('.crop-mode-select');
      const rotateBtn = obj.card.querySelector('.rotate-btn');
      
      if (cropModeSelect) {
        cropModeSelect.disabled = true;
      }
      if (rotateBtn) {
        rotateBtn.disabled = true;
      }
      if (obj.cropper) {
        obj.cropper.disable();
      }
    });

    const uploadImage = async (obj, index) => {
      let finalImageCanvas;
      const cropModeSelect = obj.card.querySelector('.crop-mode-select');
      const mode = cropModeSelect ? cropModeSelect.value : 'manual-crop';
      // Maximum output size: 2x print resolution.
      // Square: 660px print = 1320px output. Rectangle 2x3: 900px long side print = 1800px output
      // (the 2:3 crop keeps the short side at 1200, so a single 1800 cap on both axes is correct).
      // Mosaic: the crop spans the whole grid, so the cap scales by tiles on the
      // long axis (1320 per tile): 2x2 -> 2640, 2x3/3x2 -> 3960, 3x3 -> 3960.
      let MAX_OUTPUT_SIZE = IS_RECT ? 1800 : 1320;
      if (MOSAIC_CONFIG) {
        const mosaicGrid = getMosaicGrid(mode) || { cols: 2, rows: 2 };
        MAX_OUTPUT_SIZE = 1320 * Math.max(mosaicGrid.cols, mosaicGrid.rows);
      }
      
      dlog(`[DEBUG] Image ${index + 1}: Starting upload, mode=${mode}`);
      
      // Determine background color and whether to use entire image mode
      const isEntireImageMode = (mode === 'entire-black' || mode === 'entire-white');
      const bgColor = mode === 'entire-white' ? '#fff' : '#000';
      
      if (isEntireImageMode) {
        dlog(`[DEBUG] Image ${index + 1}: Using entire image mode`);
        const originalImage = new Image();
        originalImage.src = obj.dataURL;
        await new Promise(resolve => (originalImage.onload = resolve));
        
        finalImageCanvas = document.createElement('canvas');
        const imgWidth = originalImage.naturalWidth;
        const imgHeight = originalImage.naturalHeight;
        
        dlog(`[DEBUG] Image ${index + 1}: Original dimensions ${imgWidth}x${imgHeight}`);
        
        const originalMax = Math.max(imgWidth, imgHeight);
const canvasSize = Math.min(originalMax, MAX_OUTPUT_SIZE);
finalImageCanvas.width = canvasSize;
finalImageCanvas.height = canvasSize;
        const ctx = finalImageCanvas.getContext('2d');
        ctx.fillStyle = bgColor;
        ctx.fillRect(0, 0, finalImageCanvas.width, finalImageCanvas.height);
        
        const ratio = Math.min(finalImageCanvas.width / imgWidth, finalImageCanvas.height / imgHeight);
        const newWidth = imgWidth * ratio;
        const newHeight = imgHeight * ratio;
        const x = (finalImageCanvas.width - newWidth) / 2;
        const y = (finalImageCanvas.height - newHeight) / 2;
        
        ctx.drawImage(originalImage, x, y, newWidth, newHeight);
        dlog(`[DEBUG] Image ${index + 1}: Canvas created ${finalImageCanvas.width}x${finalImageCanvas.height}`);
      } else {
        // Manual crop mode
        dlog(`[DEBUG] Image ${index + 1}: Using manual crop mode`);
        if (obj.cropper) {
          try {
            finalImageCanvas = obj.cropper.getCroppedCanvas({
  maxWidth: MAX_OUTPUT_SIZE,
  maxHeight: MAX_OUTPUT_SIZE,
  imageSmoothingEnabled: true,
  imageSmoothingQuality: "high"
            });
            dlog(`[DEBUG] Image ${index + 1}: Cropped canvas created, size=${finalImageCanvas ? finalImageCanvas.width + 'x' + finalImageCanvas.height : 'NULL'}`);
          } catch (cropperError) {
            console.error(`[DEBUG] Image ${index + 1}: getCroppedCanvas ERROR:`, cropperError);
            updateStickyFooterOnly(`Cropper error for image ${index + 1}: ${cropperError.message}`, true, true);
            return { error: cropperError.message };
          }
        } else {
          console.error(`[DEBUG] Image ${index + 1}: Cropper not initialized`);
          updateStickyFooterOnly('Cropper not initialized. Please re-select images.', true, true);
          return { error: 'Cropper not initialized' };
        }
      }
      
      if (!finalImageCanvas) {
        console.error(`[DEBUG] Image ${index + 1}: finalImageCanvas is NULL`);
        return { error: 'Canvas creation failed' };
      }
      
      // v25: last gate before upload. A blank canvas here is a blank magnet,
      // so this is the most consequential of the checks - and it is the one
      // that tells us whether bad images are actually reaching orders.
      const diagFinalState = diagCanvasState(finalImageCanvas);
      if (diagFinalState === 'blank' || diagFinalState === 'uniform') {
        diagCardFailed('upload_canvas_' + diagFinalState, {
          photo_index: index + 1,
          image_px: diagMpBucket(finalImageCanvas.width, finalImageCanvas.height),
          file_ext: obj.file ? fileExtOf(obj.file.name) : 'na',
          file_size_bucket: obj.file ? fileSizeBucket(obj.file.size) : 'na',
          error_detail: mode
        });
      }

      // Track crop mode selection for this image at upload time
      if (window.gtag) {
        gtag('event', 'image_crop_mode_used', {
          'crop_mode': mode,
          'product_url': window.location.pathname,
          'max_images': MAX_IMAGES,
          'image_number': index + 1
        });
        dlog(`GA4 Event tracked: image_crop_mode_used - ${mode} for image ${index + 1}`);
      }
      
      return new Promise((resolve) => {
        dlog(`[DEBUG] Image ${index + 1}: Starting toBlob conversion`);
        finalImageCanvas.toBlob(async (blob) => {
          if (!blob) {
            console.error(`[DEBUG] Image ${index + 1}: toBlob returned NULL`);
            diagCardFailed('toblob_null', {
              photo_index: index + 1,
              image_px: diagMpBucket(finalImageCanvas.width, finalImageCanvas.height)
            });
            resolve({ error: 'Failed to create blob' });
            return;
          }
          
          dlog(`[DEBUG] Image ${index + 1}: Blob created, size=${blob.size}`);
          
          try {
            const workerUrl = 'https://teddys-upload-url-v2.mark-hatlan.workers.dev/upload-url';
            dlog(`[DEBUG] Image ${index + 1}: Fetching upload URL from worker`);
            const response = await fetch(workerUrl);
            
            if (!response.ok) {
              throw new Error(`Worker response failed with status: ${response.status}`);
            }
            
            const { uploadURL, readURL } = await response.json();
            dlog(`[DEBUG] Image ${index + 1}: Got upload URL`);
            
            if (!uploadURL || !readURL) {
              throw new Error('Could not get a valid upload URL from the Worker.');
            }

            // readURL is returned by the worker and is what goes onto the cart
            // line item. It points at the teddys-ingest bucket's public host
            // (~78 chars). It must NOT point at a Worker: T1 and T2 both fetch
            // this string server-side, and Cloudflare blocks Worker-to-Worker
            // subrequests on the same zone (error 1042). See order 2683.

            dlog(`[DEBUG] Image ${index + 1}: Uploading to R2`);
            const uploadResponse = await fetch(uploadURL, {
              method: 'PUT',
              body: blob,
              headers: {
                'Content-Type': blob.type,
              },
            });

            if (!uploadResponse.ok) {
              throw new Error(`Upload failed with status: ${uploadResponse.status}`);
            }
            
            dlog(`[DEBUG] Image ${index + 1}: Upload SUCCESS, URL=${readURL}`);
            resolve({ url: readURL, canvas: finalImageCanvas, mode: mode });

          } catch (error) {
            console.error(`[DEBUG] Image ${index + 1}: Upload ERROR:`, error);
            updateStickyFooterOnly(`Upload failed for image ${index + 1}: ${error.message}`, true, true);
            resolve({ error: error.message });
          }
        }, 'image/jpeg');
      });
    };
    
    // TEMPORARY DEBUG: Track what's happening
    dlog(`[DEBUG] Starting uploads for ${imageObjects.length} images`);
    dlog(`[DEBUG] gridItems.length = ${gridItems.length}`);
    
    // Calculate total images including quantities
    let totalImagesToUpload = 0;
    imageObjects.forEach(obj => {
      const qty = parseInt(obj.card.dataset.quantity) || 1;
      totalImagesToUpload += qty;
    });
    dlog(`[DEBUG] Total images to upload (including quantities): ${totalImagesToUpload}`);
    
    let uploadCounter = 0;
    
    // Show persistent upload progress toast
    const imageWord = totalImagesToUpload === 1 ? 'image' : 'images';
    showUploadProgressToast(`Uploading 0 of ${totalImagesToUpload} ${imageWord}...please wait.`);
    
    for (let i = 0; i < imageObjects.length; i++) {
        const obj = imageObjects[i];
        const quantity = parseInt(obj.card.dataset.quantity) || 1;
        dlog(`[DEBUG] Processing image ${i + 1} with quantity ${quantity}`);
        
        // Upload image for each quantity
        for (let q = 0; q < quantity; q++) {
            uploadCounter++;
            dlog(`[DEBUG] Uploading copy ${q + 1} of ${quantity} for image ${i + 1}`);
            
            // Update progress message (both sticky footer and toast)
            const progressMessage = `Uploading ${uploadCounter} of ${totalImagesToUpload} ${imageWord}...please wait.`;
            updateStickyFooterOnly(progressMessage, false, true);
            showUploadProgressToast(progressMessage);
            
            const result = await uploadImage(obj, uploadCounter - 1);
            
            dlog(`[DEBUG] Image ${uploadCounter}: result.url = ${result.url ? 'YES' : 'NO - ' + (result.error || 'unknown')}`);

            if (result.url) {
                uploadedUrls.push(result.url);
                const finalImageCanvas = result.canvas;
                
                // Check if canvas exists
                if (!finalImageCanvas) {
                    console.error(`[DEBUG] Image ${uploadCounter}: NO CANVAS RETURNED`);
                    uploadFailed = true;
                    continue;
                }
                
                let finalImageURL;
                try {
                    finalImageURL = finalImageCanvas.toDataURL('image/jpeg', 1.0);
                    dlog(`[DEBUG] Image ${uploadCounter}: toDataURL length = ${finalImageURL ? finalImageURL.length : 0}`);
                } catch (e) {
                    console.error(`[DEBUG] Image ${uploadCounter}: toDataURL ERROR:`, e);
                    uploadFailed = true;
                    continue;
                }
                
                let placed = false;
                let emptySlotFound = -1;
                
                for (let j = 0; j < gridItems.length; j++) {
                    const hasImg = gridItems[j].querySelector('img');
                    if (!hasImg) {
                        emptySlotFound = j;
                        dlog(`[DEBUG] Image ${uploadCounter}: Found empty slot at index ${j}`);
                        const img = document.createElement('img');
                        img.src = finalImageURL;
                        img.alt = "Grid Image";
                        img.dataset.url = result.url;
                        if (MOSAIC_CONFIG && (result.mode === 'portrait' || result.mode === 'landscape')) {
                          img.dataset.mosaicOrientation = result.mode;
                        }
                        const trashIconContainer = document.createElement('div');
                        trashIconContainer.className = "trash-icon-container";
                        trashIconContainer.innerHTML = `<svg class="trash-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>`;
                        gridItems[j].innerHTML = '';
                        gridItems[j].appendChild(img);
                        gridItems[j].appendChild(trashIconContainer);
                        placed = true;
                        if (imageGrid.style.display === 'none') {
                            imageGrid.style.display = 'grid';
                        }
                        updateAddToCartButtonState();
                        updateUploadButtonVisibility();
                        break;
                    }
                }
                
                dlog(`[DEBUG] Image ${uploadCounter}: placed=${placed}, emptySlot=${emptySlotFound}`);
                
                if (!placed) {
                    console.error(`[DEBUG] Image ${uploadCounter}: Could not place in grid!`);
                    updateStickyFooterOnly('The grid is full. Not all images could be saved.', true, true);
                    uploadFailed = true;
                }
            } else {
                console.error(`[DEBUG] Image ${uploadCounter}: UPLOAD FAILED - ${result.error}`);
                uploadFailed = true;
            }
        }
    }
    
    // TEMPORARY DEBUG: Log results before closing popup
    dlog(`[DEBUG] uploadedUrls.length = ${uploadedUrls.length}`);
    dlog(`[DEBUG] uploadFailed = ${uploadFailed}`);
    
    // Hide the upload progress toast
    hideUploadProgressToast();
    
    // Check grid state after all uploads
    let finalGridCount = 0;
    gridItems.forEach((item, idx) => {
        if (item.querySelector('img')) finalGridCount++;
    });
    dlog(`[DEBUG] Final grid image count = ${finalGridCount}`);
    // END TEMPORARY DEBUG
    
    updateR2UrlsInput();

    updateGuidanceMessage();
    updateAddToCartButtonState();
    updateUploadButtonText();
    updateUploadButtonVisibility();

    popup.style.display = 'none';
    document.body.classList.remove('popup-open');
    document.body.style.overflow = '';
    
    // Scroll to uploader container so image grid and Add to Cart are visible
    if (uploaderContainer) {
      setTimeout(() => {
        uploaderContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
    
    imageObjects.forEach(obj => {
      if (obj.cropper) {
        obj.cropper.destroy();
      }
    });
    clearAllCardWatchdogs();
    releaseAllSourceURLs();
    imageObjects = [];
    imageCardsContainer.innerHTML = '';
    
    // Remove the images below badge
    const imagesBelowBadge = document.querySelector('.images-below-badge');
    if (imagesBelowBadge) imagesBelowBadge.remove();
    
    if (uploadFailed) {
      updateStickyFooterOnly('Uploads completed with some errors.', true, true);
    } else {
      const imageWord = MAX_IMAGES === 1 ? 'image' : 'images';
      updateStickyFooterOnly(`All ${imageWord} uploaded successfully!`, false, true);
    }

    // Hide status message on mobile again after upload completes
    if (uploadStatusMessage) {
      uploadStatusMessage.classList.remove('uploading');
    }

    saveAllBtn.disabled = false;
    fileInput.value = '';
  });

  closeBtn.addEventListener('click', () => {
    // Never allow close while the Converting/Preparing prep is running. The
    // handler clears imageObjects and the cards container, which would leave
    // waitForCardsReady polling a count that can no longer be reached.
    if (prepInProgress) return;

    // Google Analytics to track popup closed without uploading
  if (window.gtag && imageObjects.length > 0) {
    gtag('event', 'Uploader_popup_closed_without_upload', {
      'images_prepared': imageObjects.length,
      'product_url': window.location.pathname
    });
    dlog('GA4 Event tracked: uploader closed without uploading', imageObjects.length, 'images');
  }
  
    popup.style.display = 'none';
    document.body.classList.remove('popup-open');
    document.body.style.overflow = '';
    
    // Scroll to uploader container so image grid and Add to Cart are visible
    if (uploaderContainer) {
      setTimeout(() => {
        uploaderContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
    
    imageObjects.forEach(obj => {
      if (obj.cropper) {
        obj.cropper.destroy();
      }
    });
    clearAllCardWatchdogs();
    releaseAllSourceURLs();
    imageObjects = [];
    imageCardsContainer.innerHTML = '';
    
    // Remove the images below badge
    const imagesBelowBadge2 = document.querySelector('.images-below-badge');
    if (imagesBelowBadge2) imagesBelowBadge2.remove();
    
    fileInput.value = '';
  });

  imageGrid.addEventListener('click', (event) => {
    const trashIconContainer = event.target.closest('.trash-icon-container');
    if (trashIconContainer) {
      const gridItem = trashIconContainer.closest('.grid-item');
      if (gridItem) {
        gridItem.innerHTML = '';

        // Google Analytics to track trash can use.
        if (window.gtag) {
  gtag('event', 'image_removed_from_grid', {
    'product_url': window.location.pathname
  });
  dlog('GA4 Event tracked: image removed from grid');
}

        let hasImages = false;
        for (let i = 0; i < gridItems.length; i++) {
          if (gridItems[i].querySelector('img')) {
            hasImages = true;
            break;
          }
        }
        if (!hasImages) {
          imageGrid.style.display = 'none';
        }
        updateR2UrlsInput();
        updateGuidanceMessage();
        updateAddToCartButtonState();
        updateUploadButtonText();
        updateUploadButtonVisibility();
      }
    }
  });

  updateAddToCartButtonState();
  updateUploadButtonText();
  updateUploadButtonVisibility();
  updateGuidanceMessage();
  
  // v17: MutationObserver to prevent Shopify's variant picker from enabling Add to Cart
  // when the required images haven't been uploaded yet
  if (addToCartBtn) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
          const currentCount = getGridImageCount();
          const shouldBeDisabled = (currentCount !== MAX_IMAGES);
          
          // If Shopify enabled the button but we don't have all images, disable it again
          if (shouldBeDisabled && !addToCartBtn.disabled) {
            dlog('Uploader v17: Shopify tried to enable Add to Cart, but images not complete. Re-disabling.');
            addToCartBtn.disabled = true;
          }
        }
      });
    });
    
    observer.observe(addToCartBtn, { attributes: true });
    dlog('Uploader v17: MutationObserver attached to Add to Cart button');
  }

  // v18: Form submit guard — last line of defense against empty __r2_image_urls
  // Catches edge cases where button state is bypassed (e.g. Facebook WebView state loss)
  const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      const r2Input = document.getElementById('r2-image-urls');
      if (!r2Input || !r2Input.value || r2Input.value.trim() === '') {
        e.preventDefault();
        e.stopImmediatePropagation();
        console.warn('Uploader v18: Form submit blocked — __r2_image_urls is empty.');
        showProductPageToast('Please upload your images before adding to cart.');
        return false;
      }
      dlog('Uploader v18: Form submit allowed — __r2_image_urls present with ' + r2Input.value.split(',').length + ' URLs.');
    }, true); // capture phase — fires before Shopify's own submit handler
    dlog('Uploader v18: Form submit guard attached.');
  }

  // Test button for diagnostics
  const testStatusBtn = document.getElementById('test-status-btn');
  if (testStatusBtn) {
    testStatusBtn.addEventListener('click', () => {
      dlog('Test button clicked!');
      updateBothStatusMessages('This is a test message!', false, true);
    });
  }
});